import { LOCALES } from "../constants";

const cs = {
  [LOCALES.CS]: {
    //All page
    "Página não encontrada": "Stránka nenalezena",
    //LOGIN PAGE
    "login.Login": "Přihlášení",
    "login.Informe seu e-mail": "Zadejte svůj e-mail",
    "login.E-mail inválido. Por favor, verifique": "Neplatný e-mail. Zkontrolujte jej prosím.",
    "login.Senha": "Heslo",
    "login.Sua senha deve possuir no mínimo 6 caracteres": "Vaše heslo musí obsahovat alespoň 6 znaků",
    "login.Esqueci minha senha": "Zapomněl(a) jsem heslo",
    "login.ENTRAR": "PŘIHLÁSIT SE",
    "login.CRIAR CONTA": "VYTVOŘIT ÚČET",
    "login.Não foi possÍvel fazer o login. Verifique seus dados e tente novamente": "Přihlášení se nezdařilo. Zkontrolujte své údaje a zkuste to znovu.",
    "login.A PLATAFORMA IOK MUDOU!": "PLATFORMA IOK SE ZMĚNILA!",
    "login.Não exibir este aviso novamente": "Toto upozornění již nezobrazovat",
    "login.Se você já possui um cadastro na antiga plataforma, ": "Pokud již máte účet na staré platformě, ",
    "login.clique aqui": "klikněte zde",
    "login. para": " pro ",
    "login.migrar": "migraci ",
    "login.seus dados e aproveitar toda a experiência IOK.": "svých dat a využití všech výhod platformy IOK.",
    "login.Sua conta não foi ativada. Por gentileza, verifique seu e-mail para realizar a ativação": "Váš účet nebyl aktivován. Zkontrolujte prosím svůj e-mail a dokončete aktivaci.",
    "login.PLATAFORMA EM MANUTENÇÃO": "PLATFORMA JE V ÚDRŽBĚ",
    "login.ESTAMOS PREPARANDO A NOVA PLATAFORMA IOK E EM BREVE ELA ESTARÁ PRONTA!": "PŘIPRAVUJEME NOVOU PLATFORMU IOK A BRZY BUDE PŘIPRAVENA!",
    "login.Migrar Conta": "Migrovat účet",
    "login.Se você já possui um cadastro na antiga plataforma, clique aqui em Migrar Conta para migrar seus dados e aproveitar toda a experiência IOK": "Pokud již máte účet na staré platformě, klikněte na Migrovat účet a přeneste svá data, abyste mohli využívat všechny funkce platformy IOK.",
    "login.Política de privacidade": "Zásady ochrany osobních údajů",
    "login.ENTENDI": "ROZUMÍM",
    "login.Para melhorar a sua experiência na plataforma e oferecer serviços personalizados, utilizamos cookies.": "Pro zlepšení vašeho zážitku z platformy a poskytování personalizovaných služeb používáme soubory cookie.",
    "login.Ao utilizar a Plataforma IOK, você automaticamente concorda com seu uso.": "Používáním platformy IOK automaticky souhlasíte s jejich používáním.",
    "login.Senha incorreta! Duas tentativas restantes antes de ter o acesso à conta bloqueado.": "Nesprávné heslo! Zbývají dva pokusy, než bude přístup k účtu zablokován.",
    "login.Senha incorreta! Uma tentativa restantes antes de ter o acesso à conta bloqueado.": "Nesprávné heslo! Zbývá jeden pokus, než bude přístup k účtu zablokován.",
    "login.Acesso bloqueado! Siga as instruções de recuperação de conta.": "Přístup byl zablokován! Postupujte podle pokynů pro obnovení účtu.",

    // REGISTER
    "DISTRIBUIDOR": "DISTRIBUTOR:Jsem distributor zařízení Prática.",
    "REDE": "SÍŤ:Jsem vlastníkem sítě.",
    "DONO": "SPOLEČNOST:Vlastním svou vlastní společnost/jsem součástí sítě.",
    "register.Informe seu e-mail cadastrado na plataforma IOK anterior": "Zadejte svůj e-mail registrovaný na předchozí platformě IOK",
    "register.E-mail inválido. Por favor, verifique": "Neplatný e-mail. Zkontrolujte jej prosím.",
    "register.BUSCAR DADOS": "VYHLEDAT ÚDAJE",
    "register.Nome da organização": "Název organizace",
    "register.Informe o nome de sua organização": "Zadejte název své organizace",
    "register.O campo nome da organização é obrigatório": "Pole Název organizace je povinné",
    "register.Este nome já existe. Por favor, escolha outro": "Tento název již existuje. Zvolte prosím jiný.",
    "register.RECUPERAR CONTA": "OBNOVIT ÚČET",
    "register.O ADMINISTRADOR DA ORGANIZAÇÃO RECEBERÁ UM E-MAIL PARA ATIVAR SUA CONTA DE USUÁRIO. POR GENTILIZA, AGUARDE": "SPRÁVCE ORGANIZACE OBDRŽÍ E-MAIL PRO AKTIVACI VAŠEHO UŽIVATELSKÉHO ÚČTU. PROSÍM, VYČKEJTE.",
    "register.E-mail não encontrado": "E-mail nebyl nalezen",
    "register.Digite seu e-mail da plataforma IOK antiga": "Zadejte svůj e-mail ze staré platformy IOK",
    "register.Não foi possível recuperar sua conta. Verifique seus dados e tente novamente": "Nepodařilo se obnovit váš účet. Zkontrolujte své údaje a zkuste to znovu.",
    "register.Não foi possível recuperar seus dados. Verifique e tente novamente": "Nepodařilo se obnovit vaše údaje. Zkontrolujte je a zkuste to znovu.",
    "register.PROSSEGUIR": "POKRAČOVAT",
    "register.VOCÊ ESTÁ SOLICITANDO ACESSO PARA A ORGANIZAÇÃO:": "ŽÁDÁTE O PŘÍSTUP K ORGANIZACI:",
    "register.COM O ADMINISTRADOR:": "SE SPRÁVCEM:",
    "register.E-mail já cadastrado na plataforma. Informe um novo e-mail ou acesse a plataforma com o e-mail já cadastrado": "Tento e-mail je již na platformě registrován. Zadejte nový e-mail nebo se přihlaste pomocí již registrovaného e-mailu.",
    "register.Empresa já cadastrada na plataforma. Por favor, informe o nome de uma nova empresa": "Společnost je již na platformě registrována. Zadejte prosím název nové společnosti.",
    "register.VOCÊ NÃO RECONHECEU O USUÁRIO {userName} COMO PARTE DA SUA ORGANIZAÇÃO E POR ISSO A CONTA DELE FOI DELETADA.": "NEPOTVRDILI JSTE UŽIVATELE {userName} JAKO SOUČÁST VAŠÍ ORGANIZACE, A PROTO BYL JEHO ÚČET SMAZÁN.",
    "register.NÂO FOI POSSÍVEL DELETAR O USÁRIO {userName}. POR GENTILEZA, TENTE NOVAMENTE MAIS TARDE.": "NEPODAŘILO SE SMAZAT UŽIVATELE {userName}. ZKUSTE TO PROSÍM ZNOVU POZDĚJI.",
    "register.CONFIRMAR": "POTVRDIT",
    "register.Não foi possível fazer o cadastro. Verifique seus dados e tente novamente": "Registraci se nepodařilo dokončit. Zkontrolujte své údaje a zkuste to znovu.",
    "register.VOCÊ RECEBERÁ UM E-MAIL PARA CONCLUIR SEU CADASTRO E ATIVAR SUA CONTA DE ADMINISTRADOR": "OBDRŽÍTE E-MAIL PRO DOKONČENÍ REGISTRACE A AKTIVACI SVÉHO SPRÁVCOVSKÉHO ÚČTU",
    "register.Nome": "Jméno",
    "register.Informe seu nome": "Zadejte své jméno",
    "register.O campo nome é obrigatório": "Pole Jméno je povinné",
    "register.E-mail": "E-mail",
    "register.Informe seu e-mail": "Zadejte svůj e-mail",
    "register.E-mail inválido. Por favor, verifique novamente": "Neplatný e-mail. Zkontrolujte jej prosím znovu.",
    "register.Telefone": "Telefon",
    "register.Informe seu telefone": "Zadejte své telefonní číslo",
    "register.Crie sua senha": "Vytvořte si heslo",
    "register.Informe sua senha": "Zadejte své heslo",
    "register.O campo senha deve conter no mínimo 6 caracteres": "Heslo musí obsahovat alespoň 6 znaků",
    "register.Confirme sua senha": "Potvrďte své heslo",
    "register.As senhas devem ser iguais": "Hesla se musí shodovat",
    "register.CRIAR CONTA": "VYTVOŘIT ÚČET",
    "register.CONTA ATIVADA COM SUCESSO": "ÚČET BYL ÚSPĚŠNĚ AKTIVOVÁN",
    "register.ACESSAR": "PŘISTOUPIT",
    "register.NÃO FOI POSSÍVEL ATIVAR SUA CONTA": "NEPODAŘILO SE AKTIVOVAT VÁŠ ÚČET",
    "register.Digite seu telefone": "Zadejte své telefonní číslo",
    "register.AGUARDE ENQUANTO TRANSFERIMOS SEUS DADOS. ESTE PROCESSO DEVE LEVAR ALGUNS MINUTOS. CASO VOCÊ POSSUA UMA GRANDE QUANTIDADE DE DADOS, A TRANSFERÊNCIA PODE LEVAR ATÉ UMA HORA.": "VYČKEJTE, ZATÍMCO PŘENÁŠÍME VAŠE DATA. TENTO PROCES MŮŽE TRVAT NĚKOLIK MINUT. POKUD MÁTE VELKÉ MNOŽSTVÍ DAT, MŮŽE PŘENOS TRVAT AŽ HODINU.",
    "register.DADOS TRANSFERIDOS COM SUCESSO! CLIQUE NO BOTÃO ABAIXO PARA ACESSAR A PLATAFORMA.": "DATA BYLA ÚSPĚŠNĚ PŘENESENA! KLIKNĚTE NA TLAČÍTKO NÍŽE PRO PŘÍSTUP K PLATFORMĚ.",
    "register.EMAIL INVÁLIDO. POR GENTILEZA, VERIFIQUE SE SUA CONTA JÁ FOI ATIVADA.": "NEPLATNÝ E-MAIL. ZKONTROLUJTE PROSÍM, ZDA BYL VÁŠ ÚČET JIŽ AKTIVOVÁN.",
    "register.Ainda não tenho uma organização. Criar": "Ještě nemám organizaci. Vytvořit",
    "register.Informe o ID da organização": "Zadejte ID organizace",
    "register.O campo com ID é obrigatório": "Pole ID je povinné",
    "register.O ADMINISTRADOR DA ORGANIZAÇÃO RECEBERÁ UM E-MAIL PARA ATIVAR SUA CONTA. POR GENTILIZA, AGUARDE": "SPRÁVCE ORGANIZACE OBDRŽÍ E-MAIL PRO AKTIVACI VAŠEHO ÚČTU. PROSÍM, VYČKEJTE.",
    "register.A nova plataforma IOK agora está dividida em organizações e possui diferentes tipos de conta, que ajudam a organizar melhor as grandes corporações, empresas e redes.": "Nová platforma IOK je nyní rozdělena do organizací a nabízí různé typy účtů, které pomáhají lépe organizovat velké korporace, společnosti a sítě.",
    "register.O administrador da minha organização já realizou a migração da conta e temos um ID. Desejo migrar meus dados de usuário.": "Správce mé organizace již provedl migraci účtu a máme ID. Chci migrovat svá uživatelská data.",
    "register.Desejo migrar a conta da minha organização e me tornar o administrador.": "Chci migrovat účet své organizace a stát se správcem.",
    "register.Conta da organização já migrada": "Účet organizace již byl migrován",
    "register.Migrar conta da organização": "Migrovat účet organizace",
    "register.A nova plataforma IOK agora conta com novas formas de acesso - que são referentes ao tipo de organização em que você atua. O responsável pela sua organização deve migrar a conta principal da empresa, se tornando o administrador, enquanto o restante dos funcionários devem se vincular a ela pelo ID fornecido.": "Nová platforma IOK nyní nabízí nové způsoby přístupu podle typu organizace, ve které působíte. Odpovědná osoba ve vaší organizaci musí migrovat hlavní účet společnosti a stát se správcem, zatímco ostatní zaměstnanci se k němu připojí pomocí poskytnutého ID.",
    "register.ID informado não corresponde a nenhuma companhia. Verifique e tente novamente": "Zadané ID neodpovídá žádné společnosti. Zkontrolujte jej a zkuste to znovu.",
    "register.VOCÊ POSSUI MUITOS MENUS, NÃO CONSEGUIMOS REALIZAR A IMPORTAÇÃO AUTOMÁTICA. SUA CONTA SERÁ ATIVADA, PORÉM OS MENUS PRECISARÃO SER MIGRADOS MANUALMENTE.": "MÁTE PŘÍLIŠ MNOHO NABÍDEK, A PROTO JE NELZE AUTOMATICKY IMPORTOVAT. VÁŠ ÚČET BUDE AKTIVOVÁN, ALE NABÍDKY BUDE NUTNÉ MIGROVAT RUČNĚ.",
    "register.PARA MIGRAR SEUS MENUS, APÓS O LOGIN, CLIQUE NO SEU NOME NO CANTO SUPERIOR DIREITO, CLIQUE EM EDITAR CONTA E DEPOIS EM IMPORTAR MENUS.": "PRO MIGRACI NABÍDEK SE PO PŘIHLÁŠENÍ KLIKNĚTE NA SVÉ JMÉNO V PRAVÉM HORNÍM ROHU, POTÉ NA UPRAVIT ÚČET A NÁSLEDNĚ NA IMPORTOVAT NABÍDKY.",
    "register.Atenção:": "Pozor:",
    "register.apenas uma pessoa da organização pode criar a conta e, depois de ativá-la, convidar os demais usuários da empresa para acessá-la.": "pouze jedna osoba v organizaci může vytvořit účet a po jeho aktivaci pozvat ostatní uživatele společnosti k přístupu.",
    "register.TOKEN DESENVOLVEDOR CANCELADO": "VÝVOJÁŘSKÝ TOKEN ZRUŠEN",
    "register.Sua senha deve estar entre 8 e 20 caracteres, ter uma letra maiúscula, uma minúscula, um número e um caractere especial": "Vaše heslo musí mít 8 až 20 znaků a obsahovat velké písmeno, malé písmeno, číslo a speciální znak",

    //HOME
    "home.Menus disponíveis na plataforma": "Nabídky dostupné na platformě",
    "home.Criados na plataforma": "Vytvořené na platformě",
    "home.Recebidos dos fornos": "Přijaté z pecí",
    "home.Equipamentos vinculados": "Přiřazená zařízení",
    "home.Total de receitas cadastradas": "Celkový počet registrovaných receptů",
    "home.Receitas": "Recepty",
    "home.Receitas em menus": "Recepty v nabídkách",
    "home.Em menus": "V nabídkách",
    "home.Receitas salvas no Cookbook": "Recepty uložené v Cookbooku",
    "home.No Cookbook": "V Cookbooku",
    "home.Atualizações": "Aktualizace",
    "home.Copa": "Copa",
    "home.Rocket": "Rocket",
    "home.Single Mag": "Single Mag",
    "home.Versão instalada": "Nainstalovaná verze",
    "home.Versão disponível": "Dostupná verze",
    "home.Usuários cadastrados": "Registrovaní uživatelé",
    "home.Aceitação pendente": "Čeká na přijetí",
    "home.Atualizado": "Aktualizováno",
    "home.OLÁ": "VÍTEJTE",
    "home.É muito bom ter você aqui!": "Jsme rádi, že jste zde!",
    "home.Com a Plataforma IOK é possível administrar seus fornos de onde estiver, criar e gerenciar receitas e menus, fazer backups, analisar os dados de seus equipamentos e muito mais!": "S platformou IOK můžete spravovat své pece odkudkoli, vytvářet a spravovat recepty a nabídky, vytvářet zálohy, analyzovat data svých zařízení a mnohem více!",
    "home.Conheça a plataforma": "Poznejte platformu",
    "home.Taxa de erro por modelo": "Míra chyb podle modelu",
    "home.Erro": "Chyba",
    "home.QUEREMOS SABER SUA OPINIÃO SOBRE": "CHCEME ZNÁT VÁŠ NÁZOR NA",
    "home.Valorizamos muito seu ponto de vista e, por isso, este formulário de pesquisa de satisfação sobre a Plataforma {model} foi criado!": "Velmi si vážíme vašeho názoru, a proto jsme vytvořili tento dotazník spokojenosti s platformou {model}!",
    "home.Valorizamos muito seu ponto de vista e, por isso, este formulário de pesquisa de satisfação sobre a linha {model} foi criado!": "Velmi si vážíme vašeho názoru, a proto jsme vytvořili tento dotazník spokojenosti s řadou {model}!",
    "home.Suas respostas nos ajudarão a aprimorar nossos serviços, garantindo que continuemos a oferecer a você a melhor experiência possível.": "Vaše odpovědi nám pomohou zlepšovat naše služby a zajistit, že vám budeme i nadále poskytovat co nejlepší zkušenost.",
    "home.Reserve uns minutinhos de seu dia e participe!": "Vyhraďte si několik minut svého času a zapojte se!",
    "home.Responder a pesquisa": "Vyplnit dotazník",
    "home.Modelos em evidência": "Doporučené modely",
    "home.Modelos": "Modely",
    "home.Total de equipamentos vinculados": "Celkový počet přiřazených zařízení",
    "home.Total de equipamentos online": "Celkový počet online zařízení",
    "home.Equipamentos online": "Online zařízení",
    "home.Países com Prática": "Země s Prática",
    "home.Países": "Země",
    "home.Aguarde enquanto carregamos os dados": "Počkejte, načítáme data",
    "home.Quase lá! Aguarde um pouco mais": "Už skoro hotovo! Ještě chvíli počkejte",
    "home.Vendas por Equipamento": "Prodeje podle zařízení",
    "home.Total de equipamentos vendidos": "Celkový počet prodaných zařízení",
    "home.Equipamentos vendidos": "Prodaná zařízení",
    "home.Clique para atualizar o software": "Klikněte pro aktualizaci softwaru",
    "home.Aceitação de software pendente": "Čeká na přijetí softwaru",
    "home.Software atualizado": "Software aktualizován",
    "home.NENHUM EQUIPAMENTO VINCULADO": "ŽÁDNÉ PŘIŘAZENÉ ZAŘÍZENÍ",
    "home.FORNOS LIGADOS": "ZAPNUTÉ PECE",
    "home.Enviando dados": "Odesílání dat",
    "home.Sem envio de dados": "Bez odesílání dat",
    "home.Criados na Plataforma": "Vytvořené na platformě",
    "home.Apenas no Cookbook": "Pouze v Cookbooku",
    "home.Usuários na companhia": "Uživatelé ve společnosti",
    "home.Inativos": "Neaktivní",
    "home.Online": "Online",
    "home.Atualizações de equipamentos": "Aktualizace zařízení",
    "home.Modelos de equipamentos": "Modely zařízení",
    "home.Atualizados": "Aktualizované",
    "home.Aguardando Aceite": "Čeká na schválení",
    "home.Desatualizados": "Neaktualizované",
    "home.Versão": "Verze",
    "home.Recente": "Nejnovější",
    "home.Legenda": "Vysvětlivky",
    "home.Chat": "Podpora",

    //MAIN
    "main.HOME": "DOMŮ",
    "main.COOKBOOK": "COOKBOOK",
    "main.MEUS MENUS": "MOJE NABÍDKY",
    "main.EQUIPAMENTOS": "ZAŘÍZENÍ",
    "main.USUÁRIOS": "UŽIVATELÉ",
    "main.ATENDIMENTOS": "PODPORA",
    "main.Idioma": "Jazyk",
    "main.Editar conta": "Upravit účet",
    "main.Configurações": "Nastavení",
    "main.Sair": "Odhlásit se",
    "main.Configurações salvas com sucesso!": "Nastavení byla úspěšně uložena!",
    "main.SALVAR": "ULOŽIT",
    "main.CONFIGURAÇÕES": "NASTAVENÍ",
    "main.Tema dark": "Tmavý režim",
    "main.Notificações": "Oznámení",
    "main.Informações para as receitas": "Nastavení receptů",
    "main.Peso:": "Hmotnost:",
    "main.Gramas": "Gramy",
    "main.Oz": "Oz",
    "main.Temperatura:": "Teplota:",
    "main.Fahrenheit (°F)": "Fahrenheit (°F)",
    "main.Conta editada com sucesso!": "Účet byl úspěšně upraven!",
    "main.EDITAR CONTA": "UPRAVIT ÚČET",
    "main.Nome": "Jméno",
    "main.Preencha com o seu nome": "Zadejte své jméno",
    "main.Telefone": "Telefon",
    "main.Preencha com o seu telefone": "Zadejte své telefonní číslo",
    "main.E-mail": "E-mail",
    "main.Preencha com o seu e-mail": "Zadejte svůj e-mail",
    "main.Alterar Senha": "Změnit heslo",
    "main.ALTERAR SENHA": "ZMĚNIT HESLO",
    "main.Senha atual": "Aktuální heslo",
    "main.Nova senha": "Nové heslo",
    "main.Confirmar nova senha": "Potvrdit nové heslo",
    "main.Informe sua senha atual": "Zadejte své aktuální heslo",
    "main.O campo senha deve conter no mínimo 6 caracteres": "Heslo musí obsahovat alespoň 6 znaků",
    "main.Informe sua nova senha": "Zadejte své nové heslo",
    "main.Confirme sua nova senha": "Potvrďte své nové heslo",
    "main.Sua nova senha deve conter no mínimo 6 caracteres": "Vaše nové heslo musí obsahovat alespoň 6 znaků",
    "main.INFORME SUA SENHA": "ZADEJTE SVÉ HESLO",
    "main.Informe sua senha para realizar a alteração de e-mail da plataforma:": "Pro změnu e-mailu na platformě zadejte své heslo:",
    "main.CONFIRMAR": "POTVRDIT",
    "main.Existem campos que não foram preenchidos corretamente": "Některá pole nebyla vyplněna správně",
    "main.Informe sua senha para prosseguir com a alteração de e-mail": "Pro pokračování ve změně e-mailu zadejte své heslo",
    "main.Senha alterada com sucesso": "Heslo bylo úspěšně změněno",
    "main.Informe sua senha atual corretamente": "Zadejte správně své aktuální heslo",
    "main.As senhas devem ser iguais": "Hesla se musí shodovat",
    "main.Nome do novo tipo de usuário": "Název nového typu uživatele",
    "main.Dê um nome para o novo tipo de usuário": "Zadejte název nového typu uživatele",
    "main.Token Desenvolvedor": "Vývojářský token",
    "main.O Token Desenvolvedor é um código único e intransferível que permite a realização de alterações": "Vývojářský token je jedinečný a nepřenositelný kód, který umožňuje provádět změny na úrovni vývoje přímo v kódu platformy prostřednictvím externích API. Ta umožňují přizpůsobení platformy tak, aby lépe vyhovovala potřebám vaší společnosti.",
    "main.É recomendado que estas alterações sejam realizadas por um profissional da área de tecnologia": "Doporučuje se, aby tyto změny prováděl odborník v oblasti informačních technologií.",
    "main.Para acessar o token, informe sua senha": "Pro přístup k tokenu zadejte své heslo",
    "main.Copie e cole o token na autenticação de todas as requisições.": "Zkopírujte a vložte token do autentizace všech požadavků.",
    "main.Seu Token": "Váš token",
    "main.Token copiado com sucesso!": "Token byl úspěšně zkopírován!",
    "main.Você deseja cancelar o preenchimento das informações?": "Chcete zrušit vyplňování informací?",
    "main.Rever tutoriais": "Znovu zobrazit návody",
    "main.Tutoriais resetados com sucesso!": "Návody byly úspěšně resetovány!",
    "main.review.tutorials": "Chcete si znovu projít návody platformy IOK?",
    "main.Procurar": "Hledat",
    "main.review.manual": "Můžete si jej také uložit do svého počítače.",
    "main.review.download": "Otevřít příručku",

    //MEUS MENUS
    "menus.Procurar menu": "Hledat menu nebo uživatele",
    "menus.Procurar menu excluído": "Hledat smazané menu",
    "menus.Menus": "Menu",
    "menus.Lixeira": "Koš",
    "menus.CRIAR MENU": "VYTVOŘIT MENU",
    "menus.IMPORTAR MENU": "IMPORTOVAT MENU",
    "menus.Os arquivos serão mantidos na lixeira por 30 dias a contar de sua data de exclusão. Após este período, eles serão excluídos definitivamente.": "Soubory budou uchovávány v koši po dobu 30 dnů od data jejich odstranění. Po uplynutí této doby budou trvale smazány.",
    "menus.VOLTAR": "zpět",
    "menus.Compatível com: ": "Kompatibilní s: ",
    "menus.Última atualização: ": "Poslední aktualizace: ",
    "menus.EXPORTAR MENU": "EXPORTOVAT MENU",
    "menus.EDITAR MENU": "UPRAVIT MENU",
    "menus.Equipamentos associados": "Přiřazená zařízení",
    "menus.Grupos": "Skupiny",
    "menus.Procurar grupo": "Hledat skupinu",
    "menus.CRIAR GRUPO": "VYTVOŘIT SKUPINU",
    "menus.receitas": "recepty",
    "menus.Nenhum grupo cadastrado": "Není zaregistrována žádná skupina",
    "menus.Nenhum menu cadastrado": "Není zaregistrováno žádné menu",
    "menus.Nome": "Název",
    "menus.Modelo": "Model",
    "menus.Atividade": "Aktivita",
    "menus.Associação": "Přiřazení",
    "menus.Exportar": "Exportovat",
    "menus.Editar": "Upravit",
    "menus.Excluir": "Smazat",
    "menus.Equips": "Zařízení",
    "menus.Receitas": "Recepty",
    "menus.Compatibilidade": "Kompatibilita",
    "menus.Última atualização": "Poslední aktualizace",
    "menus.Versão": "Verze",
    "menus.Origem": "Původ",
    "menus.Excluído por": "Smazal",
    "menus.Data de exclusão": "Datum smazání",
    "menus.Restaurar": "Obnovit",
    "menus.Existem campos que não foram preenchidos": "Existují nevyplněná pole",
    "menus.Menu criado com sucesso!": "Menu bylo úspěšně vytvořeno!",
    "menus.Existem campos com informações inválidas": "Některá pole obsahují neplatné údaje",
    "menus.SALVAR": "ULOŽIT",
    "menus.CANCELAR": "ZRUŠIT",
    "menus.Nome do menu": "Název menu",
    "menus.Informe o nome do menu": "Zadejte název menu",
    "menus.Preencha o nome do menu sem caracteres especiais": "Zadejte název menu bez speciálních znaků",
    "menus.Apenas os caracteres @#%&*-+()!\"<>:;\\/?. são permitidos": "Povoleny jsou pouze znaky @#%&*-+()!\"<>:;\\/?.",
    "menus.Selecionar": "Vybrat",
    "menus.Idioma": "Jazyk",
    "menus.Temperatura de pré-aquec 1": "Teplota předehřevu 1",
    "menus.Informe a temperatura de pré-aquec 1": "Zadejte teplotu předehřevu 1",
    "menus.Temperatura de pré-aquec 2": "Teplota předehřevu 2",
    "menus.Informe a temperatura de pré-aquec 2": "Zadejte teplotu předehřevu 2",
    "menus.Tempo para estabilização": "Doba stabilizace",
    "menus.Informe o tempo para estabilização": "Zadejte dobu stabilizace",
    "menus.Desativar pré-aquec 2": "Deaktivovat předehřev 2",
    "menus.Configurações de data e hora": "Nastavení data a času",
    "menus.Data:": "Datum:",
    "menus.DD/MM/AAAA": "DD/MM/RRRR",
    "menus.Hora:": "Čas:",
    "menus.24h": "24 h",
    "menus.AM/PM": "AM/PM",
    "menus.EUR: DD/MM/AAAA": "EUR: DD/MM/RRRR",
    "menus.USA: MM/DD/AAAA": "USA: MM/DD/RRRR",
    "menus.ISO: AAAA/MM/DD": "ISO: RRRR/MM/DD",
    "menus.Seleção de acessos para habilitar": "Výběr přístupů k povolení",
    "menus.Modo manual": "Manuální režim",
    "menus.Habilitado": "Povoleno",
    "menus.Desabilitado": "Zakázáno",
    "menus.Favoritos": "Oblíbené",
    "menus.Aquecer/Dourar": "Ohřát/Zapéct",
    "menus.Repetir receita": "Opakovat recept",
    "menus.Configurações gerais do menu": "Obecná nastavení menu",
    "menus.Temperatura:": "Teplota:",
    "menus.Fahrenheit (°F)": "Fahrenheit (°F)",
    "menus.Gramas": "Gramy",
    "menus.Oz": "Oz",
    "menus.Tema:": "Motiv:",
    "menus.Dark": "Tmavý",
    "menus.Light": "Světlý",
    "menus.Introdução:": "Úvod:",
    "menus.Ativada": "Aktivováno",
    "menus.Desativada": "Deaktivováno",
    "menus.Menu deletado com sucesso!": "Menu bylo úspěšně smazáno!",
    "menus.Não foi possivel deletar o menu": "Menu nebylo možné smazat",
    "menus.Sim": "Ano",
    "menus.Não": "Ne",
    "menus.Excluir definitivamente": "Trvale smazat",
    "menus.SALVAR NO DISPOSITIVO": "ULOŽIT DO ZAŘÍZENÍ",
    "menus.EXPORTAR": "EXPORTOVAT",
    "menus.Selecione os modelos e versões dos equipamentos que receberão o menu.": "Vyberte modely a verze zařízení, která obdrží toto menu.",
    "menus.Forno": "Trouba",
    "menus.Fundo verde": "Zelené pozadí",
    "menus.Fundo preto": "Černé pozadí",
    "menus.Linux": "Linux",
    "menus.Atenção: antes de transferir o menu de seu pen drive para o equipamento, é necessário descompactar o arquivo, exceto para menus de equipamentos Linux.": "Upozornění: před přenesením menu z USB disku do zařízení je nutné soubor rozbalit, kromě menu pro zařízení se systémem Linux.",
    "menus.Selecione os equipamentos para os quais deseja exportar o menu.": "Vyberte zařízení, do kterých chcete menu exportovat.",
    "menus.Nome do equipamento": "Název zařízení",
    "menus.Selecionar todos": "Vybrat vše",
    "menus.Selecionar todas": "Vybrat vše",
    "menus.Categoria: ": "Kategorie: ",
    "menus.Você deseja excluir o menu?": "Chcete smazat toto menu?",
    "menus.O menu será deletado da plataforma, mas permanecerá no equipamento. Uma cópia de segurança será criada automaticamente e ficará disponível por 30 dias em Meus Menus - Lixeira.": "Menu bude odstraněno z platformy, ale zůstane v zařízení. Automaticky bude vytvořena záložní kopie, která bude po dobu 30 dnů dostupná v sekci Moje menu – Koš.",
    "menus.Você deseja excluir o arquivo definitivamente?": "Chcete tento soubor trvale smazat?",
    "menus.Esta ação não poderá ser desfeita.": "Tuto akci nebude možné vrátit zpět.",
    "menus.Menu editado com sucesso!": "Menu bylo úspěšně upraveno!",
    "menus.IMPORTAR": "IMPORTOVAT",
    "menus.VERIFICAÇÃO DE VERSÃO": "KONTROLA VERZE",
    "menus.Para conferir a versão da placa de seu equipamento, siga os seguintes passos:": "Chcete-li zkontrolovat verzi desky vašeho zařízení, postupujte podle následujících kroků:",
    "menus.No forno, acesse Configurações;": "Na troubě otevřete Nastavení;",
    "menus.Insira a senha 456789;": "Zadejte heslo 456789;",
    "menus.Selecione a opção Sistema;": "Vyberte možnost Systém;",
    "menus.Selecione Informações do Fabricante;": "Vyberte Informace o výrobci;",
    "menus.O modelo de sua placa estará na linha Firmware IHM;": "Model vaší desky bude uveden na řádku Firmware IHM;",
    "menus.1ª geração A": "1. generace A",
    "menus.Firmware IHM: 12.3.4": "Firmware IHM: 12.3.4",
    "menus.1ª geração B": "1. generace B",
    "menus.2ª geração/Linux:": "2. generace/Linux:",
    "menus.Firmware IHM: L1.2.3": "Firmware IHM: L1.2.3",
    "menus.Selecione o modelo/versão do equipamento do qual deseja importar o menu. Saiba como conferir a versão de seu equipamento": "Vyberte model/verzi zařízení, ze kterého chcete importovat menu. Zjistěte, jak ověřit verzi svého zařízení",
    "menus.Como verificar a versão da placa": "Jak zkontrolovat verzi desky",
    "menus.1° Geração": "1. generace",
    "menus.Menu restaurado com sucesso!": "Menu bylo úspěšně obnoveno!",
    "menus.Não foi possivel restaurar o menu": "Menu nebylo možné obnovit",
    "menus.RESTAURAR ARQUIVO": "OBNOVIT SOUBOR",
    "menus.Você deseja restaurar o arquivo?": "Chcete obnovit tento soubor?",
    "menus.O arquivo será restaurado como uma nova versão na plataforma, na guia Todos. Para salvá-lo no equipamento, exporte-o.": "Soubor bude na platformě obnoven jako nová verze na kartě Vše. Chcete-li jej uložit do zařízení, exportujte jej.",
    "menus.EXCLUIR MENU": "SMAZAT MENU",
    "menus.Nenhum equipamento associado": "Žádné přiřazené zařízení",
    "menus.Nomeie o novo menu": "Pojmenujte nové menu",
    "menus.Nomeie o novo grupo": "Pojmenujte novou skupinu",
    "menus.Nome do grupo": "Název skupiny",
    "menus.Preencha o nome do grupo sem caracteres especiais": "Zadejte název skupiny bez speciálních znaků",
    "menus.Pré-aquecimento:": "Předehřev:",
    "menus.Grupo criado com sucesso!": "Skupina byla úspěšně vytvořena!",
    "menus.SELECIONE UMA IMAGEM": "VYBERTE OBRÁZEK",
    "menus.SELECIONAR": "VYBRAT",
    "menus.Selecionar do dispositivo": "Vybrat ze zařízení",
    "menus.Selecionar do banco de imagens": "Vybrat z databáze obrázků",
    "menus.Formato .JPG ou .PNG": "Formát .JPG nebo .PNG",
    "menus.Procurar imagem": "Hledat obrázek",
    "menus.Pertence ao menu": "Patří do menu",
    "menus.Alterar imagem": "Změnit obrázek",
    "menus.Remover imagem": "Odstranit obrázek",
    "menus.EDITAR GRUPO": "UPRAVIT SKUPINU",
    "menus.Nome:": "Název:",
    "menus.CRIAR RECEITA": "VYTVOŘIT RECEPT",
    "menus.SALVAR DO COOKBOOK": "ULOŽIT Z COOKBOOKU",
    "menus.Procurar receita do grupo": "Hledat recept ve skupině",
    "menus.Ingrediente principal": "Hlavní ingredience",
    "menus.Limpar filtros": "Vymazat filtry",
    "menus.Filtrar": "Filtrovat",
    "menus.Mover receitas": "Přesunout recepty",
    "menus.Excluir receitas": "Smazat recepty",
    "menus.Editar grupo": "Upravit skupinu",
    "menus.Excluir grupo": "Smazat skupinu",
    "menus.aqui": "zde",
    "menus.Se o código possuir apenas números e o fundo da tela for verde, pertence à 1ª A, se possuir apenas números e o fundo da tela for preta, pertence à 1ª B e, se começar com as letras L, F ou S, sua placa pertence à 2ª geração/Linux.": "Pokud kód obsahuje pouze čísla a pozadí obrazovky je zelené, patří do 1. A. Pokud obsahuje pouze čísla a pozadí je černé, patří do 1. B. Pokud začíná písmeny L, F nebo S, vaše deska patří do 2. generace/Linux.",
    "menus.1ª A - Fundo verde": "1. A – zelené pozadí",
    "menus.1ª B - Fundo preto": "1. B – černé pozadí",
    "menus.2ª - Linux": "2. – Linux",
    "menus.Tivemos um problema. Tente novamente mais tarde.": "Došlo k problému. Zkuste to prosím později.",
    "menus.Grupo editado com sucesso!": "Skupina byla úspěšně upravena!",
    "menus.AINDA NÃO HÁ GRUPOS AQUI :(": "ZATÍM ZDE NEJSOU ŽÁDNÉ SKUPINY :(",
    "menus.description.AINDA NÃO HÁ GRUPOS AQUI :(": "Klikněte na tlačítko v pravém horním rohu a přidejte skupiny.",
    "menus.NENHUM MENU NA LIXEIRA": "V KOŠI NENÍ ŽÁDNÉ MENU",
    "menus.AINDA NÃO HÁ MENUS AQUI :(": "ZATÍM ZDE NEJSOU ŽÁDNÁ MENU :(",
    "menus.description.AINDA NÃO HÁ MENUS AQUI :(": "Klikněte na jedno z tlačítek v pravém horním rohu a přidejte menu.",
    "menus.Adicionar imagem": "Přidat obrázek",
    "menus.Nome da receita": "Název receptu",
    "menus.Detalhes da receita": "Podrobnosti receptu",
    "menus.Programação da receita": "Plánování receptu",
    "menus.Nomeie sua receita": "Pojmenujte svůj recept",
    "menus.Preencha o nome da receita sem caracteres especiais": "Zadejte název receptu bez speciálních znaků",
    "menus.Tipo de prato": "Typ pokrmu",
    "menus.SALVAR RECEITAS DO COOKBOOK": "ULOŽIT RECEPTY Z COOKBOOKU",
    "menus.Selecione as receitas que deseja salvar no grupo de seu menu:": "Vyberte recepty, které chcete uložit do skupiny ve svém menu:",
    "menus.Procurar receita": "Hledat recept",
    "menus.deleteGroupSuccess": "{count, plural, one {Skupina byla úspěšně smazána!} other {Skupiny byly úspěšně smazány!}}",
    "menus.deleteGroupError": "{count, plural, one {Skupinu nebylo možné smazat.} other {Skupiny nebylo možné smazat.}}",
    "menus.EXCLUIR GRUPO": "SMAZAT SKUPINU",
    "menus.confirmDeleteGroupMessage": "{count, plural, one {Chcete skupinu trvale smazat?} other {Chcete skupiny trvale smazat?}}",
    "menus.AINDA NÃO HÁ RECEITAS AQUI :(": "ZATÍM ZDE NEJSOU ŽÁDNÉ RECEPTY :(",
    "menus.description.AINDA NÃO HÁ RECEITAS AQUI :(": "Klikněte na jedno z tlačítek v pravém horním rohu a přidejte recepty.",
    "menus.Temp. de entrada": "Vstupní teplota",
    "menus.Temp. de pré-aquec": "Teplota předehřevu",
    "menus.Ingredientes para montagem": "Ingredience pro sestavení",
    "menus.Instruções operacionais": "Provozní pokyny",
    "menus.Passo": "Krok",
    "menus.Temp": "Tepl.",
    "menus.Temp.": "Tepl.",
    "menus.Tempo": "Čas",
    "menus.Velocidade do ar": "Rychlost vzduchu",
    "menus.Micro-ondas": "Mikrovlny",
    "menus.Resistência inferior": "Spodní topné těleso",
    "menus.Informações": "Informace",
    "menus.Digite as informações do passo": "Zadejte informace o kroku",
    "menus.desativar": "deaktivovat",
    "menus.Ingredientes": "Ingredience",
    "menus.Temperatura de entrada": "Vstupní teplota",
    "menus.Equipamentos compatíveis": "Kompatibilní zařízení",
    "menus.Tempo total": "Celkový čas",
    "menus.SALVAR NO COOKBOOK": "ULOŽIT DO COOKBOOKU",
    "menus.ver localização": "zobrazit umístění",
    "menus.SELECIONE RECEITAS PARA EXCLUIR": "VYBERTE RECEPTY KE SMAZÁNÍ",
    "menus.Você deseja excluir as receitas selecionadas definitivamente?": "Chcete vybrané recepty trvale smazat?",
    "menus.Receitas deletadas com sucesso!": "Recepty byly úspěšně smazány!",
    "menus.Informe aqui os ingredientes para montagem": "Zadejte zde ingredience pro sestavení",
    "menus.Informe aqui as instruções operacionais": "Zadejte zde provozní pokyny",
    "menus.Adicionar passo": "Přidat krok",
    "menus.Receita criada com sucesso!": "Recept byl úspěšně vytvořen!",
    "menus.Ideal para:": "Ideální pro:",
    "menus.editar detalhes": "upravit podrobnosti",
    "menus.excluir": "smazat",
    "menus.editar": "upravit",
    "menus.Receita editada com sucesso!": "Recept byl úspěšně upraven!",
    "menus.Passo deletado com sucesso!": "Krok byl úspěšně smazán!",
    "menus.Não foi possivel deletar o passo": "Krok nebylo možné smazat",
    "menus.EXCLUIR PASSO": "SMAZAT KROK",
    "menus.Você deseja excluir este passo?": "Chcete tento krok smazat?",
    "menus.Esta ação não poderá ser desfeita. Caso prefira, é possível apenas desativá-lo, mantendo assim sua configuração.": "Tuto akci nebude možné vrátit zpět. Pokud chcete, můžete krok pouze deaktivovat a zachovat jeho nastavení.",
    "menus.Peso": "Hmotnost",
    "menus.Origem da receita": "Původ receptu",
    "menus.Pré-aquecimento": "Předehřev",
    "menus.Plataforma": "Platforma",
    "menus.Receita salva com sucesso!": "Recept byl úspěšně uložen!",
    "menus.Exportar receitas": "Exportovat recepty",
    "menus.expandir": "rozbalit",
    "menus.Temperatura": "Teplota",
    "menus.Vapor combinado": "Kombinovaná pára",
    "menus.Ar quente": "Horký vzduch",
    "menus.Sonda": "Sonda",
    "menus.Tempo (min)": "Čas (min)",
    "menus.Umidade (%)": "Vlhkost (%)",
    "menus.Injeção de vapor": "Vstřik páry",
    "menus.Dumper aberto": "Otevřený odtah",
    "menus.Informe o peso": "Zadejte hmotnost",
    "menus.Informe a temperatura de entrada": "Zadejte vstupní teplotu",
    "menus.Informe os ingredientes para montagem": "Zadejte ingredience pro sestavení",
    "menus.Informe as instruções operacionais": "Zadejte provozní pokyny",
    "menus.Injeção de vapor (seg)": "Vstřik páry (s)",
    "menus.Aquecer mais": "Více ohřát",
    "menus.Dourar mais": "Více opéct",
    "menus.Aquecer e dourar mais": "Více ohřát a opéct",
    "menus.Favoritar receita": "Přidat recept do oblíbených",
    "menus.Informe o tempo para aquecer mais": "Zadejte čas pro více ohřát",
    "menus.Informe o tempo para dourar mais": "Zadejte čas pro více opéct",
    "menus.Informe o tempo para aquecer e dourar mais": "Zadejte čas pro více ohřát a opéct",
    "menus.Apenas favoritos": "Pouze oblíbené",
    "menus.Forno combinado": "Kombinovaná trouba",
    "menus.Cocção múltipla": "Vícenásobné vaření",
    "menus.Receitas Technicook": "Recepty Technicook",
    "menus.Editar grupos": "Upravit skupiny",
    "menus.Informe a data": "Zadejte datum",
    "menus.Informe a hora": "Zadejte čas",
    "menus.até 300": "až 300",
    "menus.Vapor": "Pára",
    "menus.Turbina": "Ventilátor",
    "menus.Criar grupo": "Vytvořit skupinu",
    "menus.MOVER": "PŘESUNOUT",
    "menus.Configurações de data e hora:": "Nastavení data a času:",
    "menus.Configurações de acessos:": "Nastavení přístupů:",
    "menus.Modo manual:": "Ruční režim:",
    "menus.Favoritos:": "Oblíbené:",
    "menus.Aquecer/dourar:": "Ohřát/opéct:",
    "menus.Repetir receita:": "Opakovat recept:",
    "menus.Configurações gerais do menu:": "Obecná nastavení menu:",
    "menus.SELECIONE RECEITAS PARA MOVER": "VYBERTE RECEPTY K PŘESUNUTÍ",
    "menus.AVANÇAR": "POKRAČOVAT",
    "menus.Selecione ou crie um grupo no mesmo menu para mover as receitas selecionadas ou as mova para outro menu. Note que apenas os menus/grupos compatíveis com as predefinições das receitas serão exibidos.": "Vyberte nebo vytvořte skupinu ve stejném menu pro přesun vybraných receptů, nebo je přesuňte do jiného menu. Zobrazí se pouze menu/skupiny kompatibilní s přednastavením receptů.",
    "menus.Mover receitas para o mesmo menu": "Přesunout recepty do stejného menu",
    "menus.Mover receitas para outro menu": "Přesunout recepty do jiného menu",
    "menus.Selecionar grupo": "Vybrat skupinu",
    "menus.Nenhuma receita foi selecionada": "Nebyl vybrán žádný recept",
    "menus.Passo editado com sucesso!": "Krok byl úspěšně upraven!",
    "menus.Menu atualizado": "Menu bylo aktualizováno",
    "menus.até 260": "až 260",
    "menus.Umidade na câmara": "Vlhkost v komoře",
    "menus.Passos": "Kroky",
    "menus.ativar": "aktivovat",
    "menus.Informe a temperatura de pré-aquec": "Zadejte teplotu předehřevu",
    "menus.Movas as receitas selecionadas para outro menu. Note que apenas os menus compatíveis com as predefinições das receitas serão exibidos.": "Přesuňte vybrané recepty do jiného menu. Zobrazí se pouze menu kompatibilní s přednastavením receptů.",
    "menus.Sonda (°C)": "Sonda (°C)",
    "menus.Turbo Grill": "Turbo Grill",
    "menus.Pré-aquecimento padrão, conforme passo 1": "Výchozí předehřev podle kroku 1",
    "menus.salvar": "uložit",
    "menus.até": "až",
    "menus.Verificação de receita": "Kontrola receptu",
    "menus.Auto import": "Automatický import",
    "menus.Atualização forçada": "Vynucená aktualizace",
    "menus.Lista de receitas exportada com sucesso!": "Seznam receptů byl úspěšně exportován!",
    "menus.Receita movida com sucesso!": "Recept byl úspěšně přesunut!",
    "menus.Receitas movidas com sucesso!": "Recepty byly úspěšně přesunuty!",
    "menus.+ Menu": "+ Menu",
    "menus.+ Receita": "+ Recept",
    "menus.Selecione o modelo/versão do equipamento": "Vyberte model/verzi zařízení",
    "menus.Escolha um idioma compatível com o equipamento": "Vyberte jazyk kompatibilní se zařízením",
    "menus.MENU IMPORTADO COM SUCESSO!": "MENU BYLO ÚSPĚŠNĚ IMPORTOVÁNO!",
    "menus.Dourar": "Opéct",
    "menus.Não atribuir a menu": "Nepřiřazovat k menu",
    "menus.Todos": "Vše",
    "menus.Meus menus": "Moje menu",
    "menus.Para salvar uma receita, preencha todos os campos": "Pro uložení receptu vyplňte všechna pole",
    "menus.Selecione os grupos de equipamentos para os quais deseja exportar o menu.": "Vyberte skupiny zařízení, do kterých chcete menu exportovat.",
    "menus.Formato inválido. São permitidos apenas os formatos .jpeg e .png": "Neplatný formát. Povoleny jsou pouze formáty .jpeg a .png",
    "menus.Reordenar grupos": "Přeuspořádat skupiny",
    "menus.O que deseja fazer?": "Co chcete udělat?",
    "menus.Reordenar receitas": "Přeuspořádat recepty",
    "menus.ITENS REORDENADOS COM SUCESSO! PARA APLICAR AS ALTERAÇÕES NO FORNO, EXPORTE O MENU.": "POLOŽKY BYLY ÚSPĚŠNĚ PŘEUSPOŘÁDÁNY! PRO POUŽITÍ ZMĚN V TROUBĚ MENU EXPORTUJTE.",
    "menus.ARRASTE OS ITENS PARA O LOCAL DESEJADO": "PŘETÁHNĚTE POLOŽKY NA POŽADOVANÉ MÍSTO",
    "menus.Dumper": "Klapka",
    "menus.Aberto": "Otevřeno",
    "menus.Fechado": "Zavřeno",
    "menus.Intermitente": "Přerušovaný",
    "menus.Se o seu menu incluir itens sensíveis à uniformidade, recomendamos definir o Tempo de Estabilização entre 3:00 e 5:00 minutos. Caso contrário, você pode deixá-lo em 5 segundos.": "Pokud vaše menu obsahuje položky citlivé na rovnoměrnost, doporučujeme nastavit dobu stabilizace mezi 3:00 a 5:00 minutami. V opačném případě ji můžete ponechat na 5 sekundách.",
    "menus.Selecione o menu que deseja exportar:": "Vyberte menu, které chcete exportovat:",
    "menus.Temperatura de pré-aquecimento": "Teplota předehřevu",
    "menus.Temperatura de lastro": "Teplota pečicí desky",
    "menus.Temperatura de teto": "Teplota stropu",
    "menus.Volume de injeção de vapor (ml)": "Objem vstřiku páry (ml)",
    "menus.Parada de turbina": "Zastavení ventilátoru",
    "menus.Alta": "Vysoká",
    "menus.Média": "Střední",
    "menus.Baixa": "Nízká",
    "menus.a": "do",
    "menus.Valor da injeção": "Hodnota vstřiku",
    "menus.Volume: até 999ml": "Objem: až 999 ml",
    "menus.Tempo: até 15 segundos": "Čas: až 15 sekund",
    "menus.Tempo de injeção de vapor (seg)": "Doba vstřiku páry (s)",
    "menus.Atenção!": "Pozor!",
    "menus.Verifique as receitas do menu e ajuste os valores da Injeção de Vapor após alterar sua unidade de medida.": "Po změně jednotky měření zkontrolujte recepty v menu a upravte hodnoty vstřiku páry.",
    "menus.Certifique-se de que a unidade de temperatura (°C ou °F) definida no equipamento seja a mesma que foi selecionada na criação do menu:": "Ujistěte se, že jednotka teploty (°C nebo °F) nastavená v zařízení odpovídá jednotce vybrané při vytváření menu:",
    "menus.Injeção desativada": "Vstřik deaktivován",
    "menus.Selecione a unidade de temperatura que está definida no equipamento:": "Vyberte jednotku teploty nastavenou v zařízení:",
    "menus.Clique para atualizar": "Klikněte pro aktualizaci",
    "menus.A função Atualização Forçada envia automaticamente o menu para os equipamentos selecionados, e que possuam versão compatível com este tipo de atualização, na próxima vez em que forem ligados. Os fornos que não estiverem atualizados ainda precisarão realizar o aceite manual.": "Funkce Vynucená aktualizace automaticky odešle menu do vybraných zařízení s verzí kompatibilní s tímto typem aktualizace při jejich příštím zapnutí. Trouby, které nejsou aktualizované, budou stále vyžadovat ruční potvrzení.",
    "menus.As opções selecionadas estarão disponíveis nos equipamentos que receberem este menu, podendo ser utilizadas pelo operador. É possível alterar estas configurações posteriormente no próprio forno ou pela plataforma.": "Vybrané možnosti budou dostupné v zařízeních, která toto menu obdrží, a mohou být používány obsluhou. Tato nastavení lze později změnit přímo v troubě nebo prostřednictvím platformy.",
    "menus.Não foi possivel deletar as receitas": "Recepty nebylo možné odstranit",
    "menus.PRÉ": "PŘED",
    "menus.Speed Ovens": "Rychlostní trouby",
    "menus.Fornos Combinados": "Kombinované trouby",
    "menus.Fornos de Panificação": "Pekařské trouby",
    "menus.Após a criação, o tipo do menu não pode ser alterado. Ele só pode ser definido no momento da criação.": "Po vytvoření nelze typ menu změnit. Lze jej nastavit pouze při vytváření.",
    "menus.Pré-aquecimento do grupo": "Předehřev skupiny",
    "menus.Atenção: antes de transferir o menu de seu pen drive para o equipamento, é necessário descompactar o arquivo, transferindo a pasta PRATICA para o equipamento.": "Pozor: před přenesením menu z USB disku do zařízení je nutné soubor rozbalit a přenést složku PRATICA do zařízení.",
    "menus.Tamanho máximo": "Maximální velikost",
    "menus.Possibilita que o operador do forno crie parâmetros e os execute em seguida.": "Umožňuje obsluze trouby vytvářet parametry a následně je spouštět.",
    "menus.Acesso também à execução das receitas favoritas.": "Umožňuje také spouštění oblíbených receptů.",
    "menus.Possibilita que o operador adicione mais tempo para aquecer/dourar a refeição depois de sua execução.": "Umožňuje obsluze po dokončení přidat více času na ohřev/zapečení pokrmu.",
    "menus.Possibilita a repetição da receita assim que sua execução é finalizada.": "Umožňuje opakovat recept ihned po jeho dokončení.",
    "menus.Acesso exclusivo às receitas favoritas.": "Výhradní přístup k oblíbeným receptům.",
    "menus.Habilita o lembrete para o operador conferir se o alimento já está dentro do forno.": "Aktivuje připomínku pro obsluhu, aby zkontrolovala, zda je pokrm již v troubě.",
    "menus.O forno importa automaticamente, ao ligar, um menu que esteja salvo em pen drive e nele inserido.": "Trouba při zapnutí automaticky importuje menu uložené na vloženém USB disku.",
    "menus.Possibilita a cocção de diversos alimentos simultaneamente, um em cada GN.": "Umožňuje současnou přípravu různých pokrmů, každý v samostatné GN nádobě.",
    "menus.Permite a execução de receitas pré programadas, vindas de fábrica.": "Umožňuje spouštění předprogramovaných receptů dodaných z výroby.",
    "menus.Permite acesso à função turbo grill, que atinge até 300°C.": "Umožňuje přístup k funkci Turbo Grill, která dosahuje až 300 °C.",
    "menus.Possibilita que o operador adicione mais tempo para dourar a refeição depois de sua execução.": "Umožňuje obsluze přidat více času na zapečení pokrmu po jeho dokončení.",
    "menus.Permite que o operador edite grupos de receitas diretamente da tela inicial.": "Umožňuje obsluze upravovat skupiny receptů přímo z úvodní obrazovky.",
    "menus.Copiar grupos": "Kopírovat skupiny",
    "menus.Excluir grupos": "Odstranit skupiny",
    "menus.Copiar": "Kopírovat",
    "menus.Selecione grupos para copiar": "Vyberte skupiny ke kopírování",
    "menus.Selecione o destino dos grupos": "Vyberte cílové umístění skupin",
    "menus.Colar": "Vložit",
    "menus.Deseja cancelar a cópia e envio de grupos para os menus?": "Chcete zrušit kopírování a odesílání skupin do menu?",
    "menus.Grupos colados com sucesso": "{count, plural, one {Skupina byla úspěšně vložena!} other {Skupiny byly úspěšně vloženy!}}",
    "menus.Copiar receitas": "Kopírovat recepty",
    "menus.Selecione receitas para copiar": "Vyberte recepty ke kopírování",
    "menus.Selecione o destino das receitas": "Vyberte cílové umístění receptů",
    "menus.Deseja cancelar a cópia e envio de receitas para os grupos?": "Chcete zrušit kopírování a odesílání receptů do skupin?",
    "menus.Receitas coladas com sucesso": "{count, plural, one {Recept byl úspěšně vložen!} other {Recepty byly úspěšně vloženy!}}",
    "menus.Converter para C-MAX EVO": "Převést na C-MAX EVO",
    "menus.Uma cópia deste menu, adaptada para o C-MAX EVO, será criada. Recomendamos que revise cuidadosamente todos os parâmetros dos passos e atualize as receitas com novas imagens, se julgar necessário.": "Bude vytvořena kopie tohoto menu přizpůsobená pro C-MAX EVO. Doporučujeme pečlivě zkontrolovat všechny parametry kroků a v případě potřeby aktualizovat recepty novými obrázky.",
    "menus.Menu convertido com sucesso!": "Menu bylo úspěšně převedeno!",
    "menus.Não foi possível converter o menu. Tente novamente mais tarde": "Menu nebylo možné převést. Zkuste to prosím později.",
    "menus.O menu está sendo convertido... Aguarde!": "Menu se převádí... Čekejte prosím!",
    "menus.Menu incompatível com": "Menu není kompatibilní s",
    "menus.Selecione pelo menos um grupo": "Vyberte alespoň jednu skupinu",
    "menus.Selecione pelo menos um menu": "Vyberte alespoň jedno menu",
    "menus.Menu atual": "Aktuální menu",
    "menus.Copiando grupos": "{count, plural, one {Skupina se kopíruje... Čekejte prosím!} other {Skupiny se kopírují... Čekejte prosím!}}",
    "menus.Erro ao copiar grupos": "{count, plural, one {Skupinu nebylo možné zkopírovat. Zkuste to prosím později!} other {Skupiny nebylo možné zkopírovat. Zkuste to prosím později!}}",
    "menus.Procurar pelo nome do menu": "Hledat podle názvu menu",
    "menus.Escolha um grupo de destino para cada menu selecionado": "Vyberte cílovou skupinu pro každé vybrané menu!",
    "menus.Copiando receitas": "{count, plural, one {Recept se kopíruje... Čekejte prosím!} other {Recepty se kopírují... Čekejte prosím!}}",
    "menus.Erro ao copiar receitas": "{count, plural, one {Recept nebylo možné zkopírovat. Zkuste to prosím později!} other {Recepty nebylo možné zkopírovat. Zkuste to prosím později!}}",
    "menus.SELECIONE GRUPOS PARA EXCLUIR": "VYBERTE SKUPINY K ODSTRANĚNÍ",
    "menus.Padeiro noturno": "Noční pekař",
    "menus.Permite programar o início (pré-aquecimento) de uma receita específica ou informada manualmente (Modo Manual), sem a necessidade de presença de um operador no local.": "Umožňuje naplánovat spuštění (předehřev) konkrétního receptu nebo receptu zadaného ručně (Ruční režim), bez nutnosti přítomnosti obsluhy na místě.",
    "menus.Vaporizador": "Parní generátor",
    "menus.Editar receitas": "Upravit recepty",
    "menus.Permite que o operador edite receitas diretamente da tela inicial.": "Umožňuje obsluze upravovat recepty přímo z úvodní obrazovky.",
    "menus.Preencha o nome da receita": "Vyplňte název receptu",
    "menus.Tempo nível": "Čas úrovně",
    "menus.Fermentadora": "Kynárna",
    "menus.0 ou 5 a 59s": "0 nebo 5 až 59 s",
    "menus.Selecione uma imagem": "Vyberte obrázek",
    "menus.*Para criar receitas para fornos sem conectividade, crie um menu e então as receitas.": "*Chcete-li vytvořit recepty pro trouby bez připojení, nejprve vytvořte menu a poté recepty.",
    "menus.CONVERTER": "PŘEVÉST",
    "menus.Converter para FIT": "Převést na FIT",
    "menus.Converter para outro FIT": "Převést na jiný FIT",
    "menus.Selecione pelo menos um modelo FIT": "Vyberte alespoň jeden model FIT",
    "menus.O menu está sendo convertido para FIT... Aguarde!": "Menu se převádí na FIT... Čekejte prosím!",
    "menus.{count} menu(s) convertido(s) com sucesso para FIT!": "{count} menu bylo úspěšně převedeno na FIT!",
    "menus.Alguns menus foram convertidos, mas houve falha em: {models}": "Některá menu byla převedena, ale došlo k chybě u: {models}",
    "menus.Uma cópia deste menu será criada para cada modelo FIT selecionado, mantendo configurações, grupos, receitas e passos.": "Pro každý vybraný model FIT bude vytvořena kopie tohoto menu se zachováním nastavení, skupin, receptů a kroků.",
    "menus.Uma cópia deste menu será criada para cada modelo FIT selecionado, mantendo configurações, grupos, receitas e passos. No entanto, como cada forno possui dimensões e características específicas, recomendamos revisar e ajustar os parâmetros para garantir o melhor desempenho e resultado em cada equipamento. Selecione o modelo da linha FIT para qual deseja converter o menu.": "Pro každý vybraný model FIT bude vytvořena kopie tohoto menu se zachováním nastavení, skupin, receptů a kroků. Protože však každá trouba má specifické rozměry a vlastnosti, doporučujeme zkontrolovat a upravit parametry, aby byl zajištěn nejlepší výkon a výsledky na každém zařízení. Vyberte model řady FIT, na který chcete menu převést.",

    //COOKBOOK
    "cookbook.RECEITAS DISPONÍVEIS": "DOSTUPNÉ RECEPTY",
    "cookbook.RECEITAS SALVAS": "ULOŽENÉ RECEPTY",
    "cookbook.ENVIAR PARA MENU": "ODESLAT DO NABÍDKY",
    "cookbook.SALVAR": "ULOŽIT",
    "cookbook.salvar": "uložit",
    "cookbook.Filtrar por": "Filtrovat podle",
    "cookbook.Procurar receita do cookbook": "Hledat recept v Cookbooku",
    "cookbook.Equipamento": "Zařízení",
    "cookbook.Ingrediente principal": "Hlavní ingredience",
    "cookbook.Tipo de prato": "Typ pokrmu",
    "cookbook.Região": "Region",
    "cookbook.Pré-aquecimento": "Předehřev",
    "cookbook.Procurar receita": "Hledat recept",
    "cookbook.Menu": "Nabídka",
    "cookbook.ENVIAR": "ODESLAT",
    "cookbook.Procurar nome do menu": "Hledat název nabídky",
    "cookbook.Escolha um grupo deste menu": "Vyberte skupinu z této nabídky",
    "cookbook.Selecionar grupo": "Vybrat skupinu",
    "cookbook.Tivemos um problema. Tente novamente mais tarde": "Došlo k problému. Zkuste to prosím znovu později.",
    "cookbook.Receita adicionada com sucesso!": "Recept byl úspěšně přidán!",
    "cookbook.Não foi possível adicionar a receita. Tente novamente mais tarde": "Nepodařilo se přidat recept. Zkuste to prosím znovu později.",
    "cookbook.Selecione um menu e um grupo para enviar esta receita": "Vyberte nabídku a skupinu, do které chcete tento recept odeslat",
    "cookbook.A receita não foi adicionada ao menu pois não há grupos criados": "Recept nebyl přidán do nabídky, protože nebyly vytvořeny žádné skupiny",
    "cookbook.Selecione o modelo do equipamento primeiro": "Nejprve vyberte model zařízení",
    "cookbook.Grupo": "Skupina",
    "cookbook.Não foi possível salvar os passos da receita": "Nepodařilo se uložit kroky receptu",
    "cookbook.Bovina": "Hovězí",
    "cookbook.Frango": "Kuřecí",
    "cookbook.Ovos": "Vejce",
    "cookbook.Pães": "Pečivo",
    "cookbook.Peixes": "Ryby",
    "cookbook.Queijo": "Sýr",
    "cookbook.Suína": "Vepřové",
    "cookbook.Vegetais": "Zelenina",
    "cookbook.Outros": "Ostatní",
    "cookbook.Entradas/aperitivos": "Předkrmy/aperitivy",
    "cookbook.Principais": "Hlavní chody",
    "cookbook.Snacks": "Svačiny",
    "cookbook.Pizzas": "Pizzy",
    "cookbook.Massas": "Těstoviny",
    "cookbook.Acompanhamentos": "Přílohy",
    "cookbook.Sobremesas": "Dezerty",
    "cookbook.Manhã": "Snídaně",
    "cookbook.Padaria": "Pekárna",
    "cookbook.Todos": "Vše",
    "cookbook.Não atribuir origem": "Nepřiřazovat původ",
    "cookbook.Brasil": "Brazílie",
    "cookbook.Alemanha": "Německo",
    "cookbook.França": "Francie",
    "cookbook.Rússia": "Rusko",
    "cookbook.China": "Čína",
    "cookbook.Japão": "Japonsko",
    "cookbook.Itália": "Itálie",
    "cookbook.Egito": "Egypt",
    "cookbook.Grécia": "Řecko",
    "cookbook.Argentina": "Argentina",
    "cookbook.África": "Afrika",
    "cookbook.Estados Unidos": "Spojené státy",
    "cookbook.Coreia": "Korea",
    "cookbook.Turquia": "Turecko",
    "cookbook.Ideal para": "Ideální pro",
    "cookbook.Polônia": "Polsko",
    "cookbook.Sanduíches": "Sendviče",
    "cookbook.Nova Receita": "Nový recept",

    //EQUIPAMENTOS
    "equipment.equipamentos": "zařízení",
    "equipment.procurar equipamento": "Hledat zařízení nebo uživatele",
    "equipment.adicionar equipamento": "přidat zařízení",
    "equipment.atualizar equipamento": "aktualizovat zařízení",
    "equipment.+ equipamentos": "+ zařízení",
    "equipment.buscar equipamento": "Vyhledat zařízení",
    "equipment.Desvincular": "Odpojit",
    "equipment.Editar": "Upravit",
    "equipment.sem conteúdo": "ZATÍM ZDE NEJSOU ŽÁDNÁ ZAŘÍZENÍ :(",
    "equipment.description.sem conteúdo": "Klikněte na tlačítko Přidat zařízení v pravém horním rohu a propojte své trouby.",
    "equipment.editar equipamento": "upravit zařízení",
    "equipment.equipamento editado com sucesso!": "Zařízení bylo úspěšně upraveno!",
    "equipment.não foi possível editar o equipamento. Tente novamente mais tarde": "Zařízení nebylo možné upravit. Zkuste to prosím později.",
    "equipment.Menu exportado com sucesso!": "Menu bylo úspěšně exportováno!",
    "equipment.Não foi possível exportar o menu. Tente novamente mais tarde": "Menu nebylo možné exportovat. Zkuste to prosím později.",
    "equipment.Selecione pelo menos um equipamento para enviar o menu": "Vyberte alespoň jedno zařízení pro odeslání menu",
    "equipment.Informações do menu": "Informace o menu",
    "equipment.Procurar receita ou grupo": "Hledat recept nebo skupinu",
    "equipment.Grupo": "Skupina",
    "equipment.Grupos de equipamentos": "Skupiny zařízení",
    "equipment.Receita": "Recept",
    "equipment.Quantidade": "Počet",
    "equipment.Receitas mais preparadas no equipamento durante o período": "Nejčastěji spouštěné recepty na zařízení během vybraného období",
    "equipment.Informações de limpeza": "Informace o čištění",
    "equipment.Data da limpeza": "Datum čištění",
    "equipment.Hora da limpeza": "Čas čištění",
    "equipment.nome": "Název",
    "equipment.modelo": "Model",
    "equipment.categoria": "Kategorie",
    "equipment.loja": "Provozovna",
    "desvincular equipamento": "Odpojit zařízení",
    "equipment.unlink.paragrafo 1": "Chcete odpojit zařízení od platformy IOK?",
    "equipment.unlink.paragrafo 2": "Poté již nebude možné spravovat jeho nastavení a menu prostřednictvím platformy, pokud zařízení znovu nepřipojíte podle pokynů pro připojení.",
    "equipamento desvinculado com sucesso!": "Zařízení bylo úspěšně odpojeno!",
    "equipment.ocorreu um erro. Tente novamente mais tarde": "Došlo k chybě. Zkuste to prosím později.",
    "equipment.sim": "Ano",
    "equipment.não": "Ne",
    "equipment.Encerrar acesso remoto": "Ukončit vzdálený přístup",
    "equipment.Horas sem limpeza": "Hodiny bez čištění",
    "equipment.Histórico de eventos": "Historie událostí",
    "equipment.Histórico de eventos do forno": "Historie událostí trouby",
    "equipment.Histórico de eventos da fermentadora": "Historie událostí kynárny",
    "equipment.Receitas executadas": "Spuštěné recepty",
    "equipment.Hoje": "Dnes",
    "equipment.Tempo de porta aberta": "Doba otevřených dveří",
    "equipment.Tempo médio aproximado": "Přibližný průměrný čas",
    "equipment.Filtrar eventos": "Filtrovat události",
    "equipment.Evento": "Událost",
    "equipment.Data": "Datum",
    "equipment.ERRO SENSOR RI": "Chyba senzoru spodního topného tělesa",
    "equipment.ERRO COM INV. DE FREQ.": "Chyba frekvenčního měniče",
    "equipment.ERRO MAGNETRON": "Chyba magnetronu",
    "equipment.ERRO SENSOR CAMARA": "Chyba senzoru komory",
    "equipment.ERRO CAN": "Chyba CAN",
    "equipment.Erro INVERSOR DE FREQUENCIA": "Chyba frekvenčního měniče",
    "equipment.ERRO DO MODELO DO EQUIPAMENTO": "Chyba modelu zařízení",
    "equipment.ERRO PAINEL": "Chyba panelu",
    "equipment.ERRO INV.FREQ.STATUS": "Chyba stavu frekvenčního měniče",
    "equipment.ERRO SENSOR BOARD": "Chyba senzoru desky",
    "equipment.ERRO ENERGY": "Chyba napájení",
    "equipment.ERRO I2C": "Chyba I2C",
    "equipment.EQUIPAMENTO LIGADO": "Zařízení zapnuto",
    "equipment.EQUIPAMENTO DESLIGADO": "Zařízení vypnuto",
    "equipment.Plataforma": "Platforma",
    "equipment.Forno": "Trouba",
    "equipment.Origem": "Původ",
    "equipment.Locais": "Lokality",
    "equipment.não foi possível carregar as entidades": "Nepodařilo se načíst entity",
    "equipment.conceder acesso remoto a": "Udělit vzdálený přístup pro",
    "equipment.atualizar software": "aktualizovat software",
    "equipment.suporte": "podpora",
    "equipment.PIN": "PIN",
    "equipment.nome do equipamento": "Název zařízení",
    "equipment.vinculado à loja": "Přiřazeno k provozovně",
    "equipment.cadastrar loja": "Registrovat provozovnu",
    "equipment.informe o PIN do forno": "Zadejte PIN trouby",
    "equipment.preencha o PIN do forno": "Vyplňte PIN trouby",
    "equipment.adicione um nome para facilitar seu reconhecimento": "Přidejte název pro snadnější identifikaci",
    "equipment.preencha o nome do equipamento": "Vyplňte název zařízení",
    "equipment.selecionar": "Vybrat",
    "equipment.nome fantasia": "Obchodní název",
    "equipment.informe o nome fantasia": "Zadejte obchodní název",
    "equipment.preencha o nome fantasia": "Vyplňte obchodní název",
    "equipment.CNPJ": "CNPJ",
    "equipment.XX.XXX.XXX/0001.XX": "XX.XXX.XXX/0001.XX",
    "equipment.preencha o CNPJ": "Vyplňte CNPJ",
    "equipment.CEP": "PSČ",
    "equipment.00000-000": "00000-000",
    "equipment.preencha o CEP": "Vyplňte PSČ",
    "equipment.cidade": "Město",
    "equipment.informe a cidade": "Zadejte město",
    "equipment.preencha a cidade": "Vyplňte město",
    "equipment.UF": "Stát",
    "equipment.bairro": "Čtvrť",
    "equipment.informe o bairro": "Zadejte čtvrť",
    "equipment.endereço": "Adresa",
    "equipment.informe o seu endereço": "Zadejte svou adresu",
    "equipment.preencha o seu endereço": "Vyplňte svou adresu",
    "equipment.Nº": "Č.",
    "equipment.equipamento cadastrado com sucesso!": "Zařízení bylo úspěšně zaregistrováno!",
    "equipment.ocorreu um erro": "Došlo k chybě",
    "equipment.preencha o modelo": "Vyplňte model",
    "equipment.selecione uma categoria": "Vyberte kategorii",
    "equipment.selecione uma loja": "Vyberte provozovnu",
    "equipment.preencha o bairro": "Vyplňte čtvrť",
    "equipment.não foi possível cadastrar o equipamento. Tente novamente mais tarde": "Zařízení nebylo možné zaregistrovat. Zkuste to prosím později.",
    "equipment.loja cadastrada com sucesso": "Provozovna byla úspěšně zaregistrována",
    "equipment.não foi possível cadastrar a loja. Tente novamente mais tarde": "Provozovnu nebylo možné zaregistrovat. Zkuste to prosím později.",
    "equipment.equipment": "zařízení",
    "equipment.search equipment": "hledat zařízení",
    "equipment.add equipment": "přidat zařízení",
    "equipment.update equipment": "aktualizovat zařízení",
    "equipment.plus equipment": "+ zařízení",
    "equipment.Procurar equipamento": "Hledat zařízení",
    "equipment.EQUIPAMENTOS": "ZAŘÍZENÍ",
    "equipment.Atualizar equipamento": "Aktualizovat zařízení",
    "equipment.Atualizar equipamentos": "Aktualizovat zařízení",
    "equipment.confirmar": "potvrdit",
    "equipment.Selecione os modelos que deseja atualizar:": "Vyberte modely, které chcete aktualizovat:",
    "equipment.Como deseja realizar a atualização?": "Jak chcete aktualizaci provést?",
    "equipment.Enviar atualização pela plataforma (internet)": "Odeslat aktualizaci přes platformu (internet)",
    "equipment.Salvar arquivo de atualização no dispositivo": "Uložit aktualizační soubor do zařízení",
    "equipment.Linha Express": "Řada Express",
    "equipment.Escolha como deseja realizar a atualização": "Vyberte způsob provedení aktualizace",
    "equipment.Selecione ao menos um modelo de equipamento para atualizar": "Vyberte alespoň jeden model zařízení k aktualizaci",
    "equipment.Status: ": "Stav: ",
    "equipment.Número de série:": "Sériové číslo:",
    "equipment.Menu:": "Menu:",
    "equipment.Status:": "Stav:",
    "equipment.Número de série": "Sériové číslo",
    "equipment.Menu": "Menu",
    "equipment.Loja: ": "Provozovna: ",
    "equipment.End:": "Adr.: ",
    "equipment.Endereço:": "Adresa: ",
    "equipment.Cidade:": "Město: ",
    "equipment.CEP:": "PSČ: ",
    "equipment.Atualização de software enviada com sucesso!": "Aktualizace softwaru byla úspěšně odeslána!",
    "equipment.Não foi possível enviar a atualização de software. Tente novamente mais tarde": "Aktualizaci softwaru nebylo možné odeslat. Zkuste to prosím později.",
    "equipment.Download realizado com sucesso": "Stažení bylo úspěšně dokončeno",
    "equipment.Não foi possível realizar o download. Tente novamente mais tarde": "Stažení nebylo možné provést. Zkuste to prosím později.",
    "equipment.Solicitação processada com erro. Tente novamente mais tarde": "Požadavek byl zpracován s chybou. Zkuste to prosím později.",
    "equipment.Preencha o nome da versão": "Vyplňte název verze",
    "equipment.Informe aqui todas as alterações desta nova versão": "Zde uveďte všechny změny této nové verze",
    "equipment.Nova versão de software atualizada com sucesso!": "Nová verze softwaru byla úspěšně aktualizována!",
    "equipment.Informe pelo menos uma mudança nesta versão": "Uveďte alespoň jednu změnu v této verzi",
    "equipment.Falha ao transformar o arquivo em Blob": "Nepodařilo se převést soubor na Blob",
    "equipment.Erro ao criar Blob a partir do arquivo": "Chyba při vytváření Blob ze souboru",
    "equipment.Falha ao ler o arquivo": "Nepodařilo se přečíst soubor",
    "equipment.selecionar tipo": "vybrat typ",
    "equipment.selecione o tipo da versão": "vyberte typ verze",
    "equipment.atualização": "AKTUALIZACE",
    "equipment.Selecione abaixo o que deseja fazer:": "Níže vyberte, co chcete provést:",
    "equipment.Atualizar meus equipamentos": "Aktualizovat moje zařízení",
    "equipment.Enviar atualização para usuários selecionados": "Odeslat aktualizaci vybraným uživatelům",
    "equipment.ENVIAR": "ODESLAT",
    "equipment.ENVIAR ATUALIZAÇÃO": "ODESLAT AKTUALIZACI",
    "equipment.Selecione os e-mails para os quais deseja enviar a atualização:": "Vyberte e-mailové adresy, na které chcete aktualizaci odeslat:",
    "equipment.A atualização disponibilizada no dia": "Aktualizace zveřejněná dne",
    "equipment.referente ao equipamento": "týkající se zařízení",
    "equipment.contempla o seguinte:": "obsahuje následující:",
    "equipment.Selecionar arquivo para envio": "Vybrat soubor k odeslání",
    "equipment.Por favor, selecione um arquivo .tar": "Vyberte prosím soubor .tar",
    "equipment.Selecione o modelo do equipamento:": "Vyberte model zařízení:",
    "equipment.Selecione uma opção": "Vyberte možnost",
    "equipment.Nomeie a versão": "Pojmenujte verzi",
    "equipment.Clique sobre o arquivo que deseja baixar:": "Klikněte na soubor, který chcete stáhnout:",
    "equipment.Baixar atualização": "Stáhnout aktualizaci",
    "equipment.Versões": "Verze",
    "equipment.e superiores": "a vyšší",
    "equipment.name": "název",
    "equipment.model": "model",
    "equipment.category": "kategorie",
    "equipment.store": "provozovna",
    "FIT Express/FIT ST": "FIT Express/FIT ST",
    "Copa/Single Mag/Rocket": "Copa/Single Mag/Rocket",
    "Forza STi": "Forza STi",
    "TSi": "TSi",
    "FIT Express": "FIT Express",
    "FIT ST": "FIT ST",
    "FIT Express, FIT ST": "FIT Express, FIT ST",
    "Copa Express, Rocket Express, Copa Single Mag": "Copa Express, Rocket Express, Copa Single Mag",
    "equipment.e": "a",
    "equipment.Últimas versões de software:": "Nejnovější verze softwaru:",
    "equipment.Você não possui nenhum equipamento desatualizado": "Nemáte žádné zařízení se zastaralým softwarem",
    "equipment.grupos": "skupiny",
    "equipment.não foi possível carregar os grupos de equipamentos da companhia": "Nepodařilo se načíst skupiny zařízení společnosti",
    "equipment.vinculado ao grupo": "Přiřazeno ke skupině",
    "equipment.selecione um grupo": "Vyberte skupinu",
    "equipment.cadastrar grupo": "Registrovat skupinu",
    "equipment.Número de Série": "Sériové číslo",
    "equipment.Versão": "Verze",
    "equipment.não foi possível cadastrar o equipamento. Selecione ou cadastre um grupo": "Zařízení nebylo možné zaregistrovat. Vyberte nebo vytvořte skupinu.",
    "equipment.CRIE GRUPOS DE EQUIPAMENTOS!": "VYTVOŘTE SKUPINY ZAŘÍZENÍ!",
    "equipment.Para que os usuários vinculados à conta possam visualizar os equipamentos você precisa:": "Aby uživatelé přiřazení k účtu mohli zobrazit zařízení, je třeba:",
    "equipment.1) Criar grupo(s);": "1) Vytvořit skupinu(y);",
    "equipment.2) Atribuir equipamento(s) ao grupo;": "2) Přiřadit zařízení ke skupině;",
    "equipment.3) Atribuir usuário(s) ao grupo.": "3) Přiřadit uživatele ke skupině.",
    "equipment.Status software": "Stav softwaru",
    "equipment.Status menu": "Stav menu",
    "equipment.Pendente": "Čekající",
    "equipment.Aceito": "Přijato",
    "equipment.Recusado": "Odmítnuto",
    "equipment.Atualizar software": "Aktualizovat software",
    "equipment.Deseja enviar a atualização para o equipamento selecionado?": "Chcete odeslat aktualizaci vybranému zařízení?",
    "equipment.Companhia": "Společnost",
    "equipment.Exportar menu": "Exportovat menu",
    "equipment.companhias": "společnosti",
    "equipment.Nome da companhia": "Název společnosti",
    "equipment.Procurar equipamento, usuário ou companhia": "Hledat zařízení, uživatele nebo společnost",
    "equipment.Versão da power": "Verze Power",
    "equipment.AINDA NÃO HÁ DADOS DE RECEITAS AQUI :(": "ZATÍM ZDE NEJSOU ŽÁDNÁ DATA O RECEPTECH :(",
    "equipment.AINDA NÃO HÁ DADOS DE LIMPEZAS AQUI :(": "ZATÍM ZDE NEJSOU ŽÁDNÁ DATA O ČIŠTĚNÍ :(",
    "equipment.AINDA NÃO HÁ DADOS DE EVENTOS AQUI :(": "ZATÍM ZDE NEJSOU ŽÁDNÁ DATA O UDÁLOSTECH :(",
    "ID": "ID",
    "equipment.Hora": "Čas",
    "equipment.EVENTOS MAIS OCORRIDOS NO EQUIPAMENTO DURANTE O PERÍODO": "NEJČASTĚJŠÍ UDÁLOSTI NA ZAŘÍZENÍ BĚHEM OBDOBÍ",
    "equipment.hour": "h",
    "equipment.minutes": "min",
    "equipment.date format": "DD/MM/RRRR",
    "equipment.preparada": "provedena",
    "equipment.vezes": "krát",
    "equipment.vez": "krát",
    "equipment.Ver": "Zobrazit",
    "equipment.Os dados são mantidos pela plataforma pelo tempo necessário para suporte, manutenção e evolução dos produtos.": "Data jsou na platformě uchovávána po dobu nezbytnou pro podporu, údržbu a další vývoj produktů.",
    "equipment.Ligado": "Zapnuto",
    "equipment.Desligado": "Vypnuto",
    "equipment.CAN ERROR": "Chyba CAN",
    "equipment.CAMERA SENSOR ERROR": "Chyba senzoru komory",
    "equipment.STEAM/RI SENSOR ERROR": "Chyba senzoru RI",
    "equipment.PROBE 1 ERROR": "Upozornění sondy 1",
    "equipment.PROBE 2 ERROR": "Upozornění sondy 2",
    "equipment.PROBE 3 ERROR": "Upozornění sondy 3",
    "equipment.PROBE 4 ERROR": "Upozornění sondy 4",
    "equipment.PROBE 5 ERROR": "Upozornění sondy 5",
    "equipment.PROBE 6 ERROR": "Upozornění sondy 6",
    "equipment.GENERAL PROBE ERROR": "Obecná chyba sondy",
    "equipment.WATER LACK ERROR": "Upozornění na nedostatek vody",
    "equipment.HIGH PANEL TEMPERATURE ERROR": "Upozornění na vysokou teplotu panelu",
    "equipment.FREQUENCY INVERTER GENERAL ERROR": "Obecná chyba frekvenčního měniče",
    "equipment.FREQUENCY INVERTER COMMUNICATION ERROR": "Upozornění na komunikaci frekvenčního měniče",
    "equipment.FREQUENCY INVERTER STATUS ERROR": "Upozornění na stav frekvenčního měniče",
    "equipment.CLEANING NOT COMPLETED ERROR": "Upozornění na nedokončené čištění",
    "equipment.MAGNETRON ERROR": "Upozornění magnetronu",
    "equipment.EQUIPMENT FAMILY/MODEL ERROR": "Chyba modelu zařízení",
    "equipment.BOARD TEMPERATURE SENSOR ERROR": "Upozornění senzoru teploty desky",
    "equipment.ENERGY MODULE ERROR": "Chyba energetického modulu",
    "equipment.POWER BOARD I2C BUS ERROR": "Chyba napájecí desky",
    "equipment.GAS SYSTEM ERROR": "Chyba plynového systému",
    "equipment.VERY HIGH PANEL TEMPERATURE ERROR": "Kritická chyba velmi vysoké teploty panelu",
    "equipment.POWER ON": "Zapnuto",
    "equipment.POWER OFF": "Vypnuto",
    "equipment.DOOR OPENED": "Dveře otevřeny",
    "equipment.DOOR CLOSED": "Dveře zavřeny",
    "equipment.CLEANING CANCELED ERROR": "Čištění zrušeno uživatelem",
    "equipment.PIN não encontrado. Por favor, verifique e tente novamente": "PIN nebyl nalezen. Zkontrolujte jej a zkuste to znovu.",
    "equipment.Ultracongeladores": "Šokové zchlazovače",
    "equipment.PIN já vinculado a outra conta": "PIN je již propojen s jiným účtem",
    "equipment.Equipamento já cadastrado nesta conta": "Zařízení je již zaregistrováno k tomuto účtu",
    "equipment.Não foi possível validar o PIN. Tente novamente": "PIN se nepodařilo ověřit. Zkuste to znovu",
    "equipment.Modelo definido pelo equipamento": "Určeno zařízením",
    "equipment.Número de série offline inválido": "Zadejte sedm číslic bez mezer a bez nuly na začátku",
    "equipment.Número de série já cadastrado": "Sériové číslo je již registrováno",
    "equipment.Online": "Zapnuto",
    "equipment.Offline": "Vypnuto",
    "equipment.Exibir apenas eventos": "Zobrazit pouze události",
    "equipment.Endereço": "Adresa",
    "equipment.EQUIPMENT CONNECTED TO THE PLATFORM": "Zařízení připojeno k platformě",
    "equipment.EQUIPMENT DISCONNECTED FROM THE PLATFORM": "Zařízení odpojeno od platformy",
    "equipment.MENU RECEIVED FROM THE PLATFORM": "Menu z platformy přijato uživatelem",
    "equipment.MENU REJECTED BY THE USER": "Menu z platformy odmítnuto uživatelem",
    "equipment.CONNECTED TO THE INTERNET": "Připojeno k internetu",
    "equipment.DISCONNECTED FROM THE INTERNET": "Odpojeno od internetu",
    "equipment.Infelizmente, não há versões compatíveis com este equipamento que realizem o envio de dados.": "Bohužel pro toto zařízení neexistují kompatibilní verze podporující odesílání dat.",
    "equipment.O equipamento": "Zařízení",
    "equipment.deve ser atualizado para a versão mais recente de software para que passe a enviar os dados para a plataforma": "musí být aktualizováno na nejnovější verzi softwaru, aby mohlo odesílat data na platformu",
    "equipment.Versão do seu equipamento": "Verze vašeho zařízení",
    "equipment.Versão disponível": "Dostupná verze",
    "equipment.Selecione abaixo como deseja enviar a atualização para seu equipamento": "Níže vyberte způsob odeslání aktualizace do zařízení",
    "equipment.Salvar no dispositivo": "Uložit do zařízení",
    "equipment.Enviar pela internet": "Odeslat přes internet",
    "equipment.Cliente": "Zákazník",
    "equipment.NÚMERO DE SÉRIE NÃO ENCONTRADO": "SÉRIOVÉ ČÍSLO NENALEZENO",
    "equipment.BUSCAR": "HLEDAT",
    "equipment.ACESSADOS RECENTEMENTE": "NEDÁVNO OTEVŘENÉ",
    "equipment.SEM BUSCAS RECENTES": "ŽÁDNÁ NEDÁVNÁ HLEDÁNÍ",
    "equipment.description.SEM BUSCAS RECENTES": "Pro vyhledání zařízení použijte sériové číslo.",
    "equipment.Procurar equipamento pelo número de série": "Hledat zařízení podle sériového čísla",
    "equipment.AIR FILTER CLEANING COMPLETED": "Čištění vzduchového filtru dokončeno",
    "equipment.AIR FILTER CLEANING REJECTED": "Čištění vzduchového filtru odmítnuto",
    "equipment.CATALYTIC FILTER CLEANING COMPLETED": "Čištění katalytického filtru dokončeno",
    "equipment.CATALYTIC FILTER CLEANING REJECTED": "Čištění katalytického filtru odmítnuto",
    "equipment.Endereço (rua, avenida, rodovia)": "Adresa (ulice, třída, silnice)",
    "equipment.Nº/Km": "Č./Km",
    "equipment.ID do equipamento": "ID zařízení",
    "equipment.Todo equipamento deve ser vinculado a um grupo. Selecione um grupo da lista ou cadastre um novo clicando em + Cadastrar grupo.": "Každé zařízení musí být přiřazeno ke skupině. Vyberte skupinu ze seznamu nebo vytvořte novou kliknutím na + Registrovat skupinu.",
    "equipment.Nomeie seu forno": "Pojmenujte svou troubu",
    "equipment.Para visualizar o PIN, acesse nas configurações do equipamento a Plataforma Virtual IOK.": "Pro zobrazení PIN přejděte v nastavení zařízení do Virtuální platformy IOK.",
    "equipment.Vinculação IOK": "Připojení k IOK",
   "equipment.Preparações": "Spuštění",
    "equipment.recipeTable.recipe": "Recept",
    "equipment.recipeTable.origin": "Pův.",
    "equipment.recipeTable.executions": "Spuš.",
    "equipment.recipeTable.lastExecution": "Poslední spuštění",
    "equipment.Última preparação": "Poslední spuštění",
    "equipment.localização": "lokalita",
    "equipment.AINDA NÃO HÁ NENHUMA LOCALIZAÇÃO CADASTRADA :(": "ZATÍM NENÍ ZAREGISTROVÁNA ŽÁDNÁ LOKALITA :(",
    "equipment.description.AINDA NÃO HÁ NENHUMA LOCALIZAÇÃO CADASTRADA :(": "Klikněte na tlačítko v pravém horním rohu a přidejte lokality.",
    "equipment.Procurar empresa ou local": "Hledat společnost nebo lokalitu",
    "equipment.Adicionar localização": "Přidat lokalitu",
    "equipment.Adicionar": "Přidat",
    "equipment.espaço": "prostor",
    "equipment.local": "místo",
    "equipment.EXCLUIR LOCALIZAÇÃO": "ODSTRANIT LOKALITU",
    "equipment.Você deseja excluir esta localização?": "Chcete tuto lokalitu odstranit?",
    "equipment.Ao fazer isso, os equipamentos atrelados à ela não exibirão nenhuma localização, sendo necessário informar um novo local para eles.": "Po odstranění nebudou přiřazená zařízení zobrazovat žádnou lokalitu a bude nutné jim přiřadit novou.",
    "equipment.Localização deletada com sucesso!": "Lokalita byla úspěšně odstraněna!",
    "equipment.Erro ao deletar a localização. Tente novamente mais tarde": "Chyba při odstraňování lokality. Zkuste to prosím později.",
    "equipment.Não foi possivel deletar a localização": "Lokalitu nebylo možné odstranit",
    "equipment.Localização adicionada com sucesso!": "Lokalita byla úspěšně přidána!",
    "equipment.Não foi possível adicionar a localização. Tente novamente mais tarde": "Lokalitu nebylo možné přidat. Zkuste to prosím později.",
    "equipment.Nome do espaço": "Název prostoru",
    "equipment.Informe o nome do espaço": "Zadejte název prostoru",
    "equipment.Preencha o nome do espaço": "Vyplňte název prostoru",
    "equipment.país": "země",
    "equipment.informe o país": "Zadejte zemi",
    "equipment.preencha o país": "Vyplňte zemi",
    "equipment.Localização editada com sucesso!": "Lokalita byla úspěšně upravena!",
    "equipment.Não foi possível editar a localização. Tente novamente mais tarde": "Lokalitu nebylo možné upravit. Zkuste to prosím později.",
    "equipment.Editar localização": "Upravit lokalitu",
    "equipment.Pico de preparações": "Špička spuštění",
    "equipment.informações da semana": "informace za týden",
    "equipment.horários de pico": "špičkové časy",
    "equipment.horário de pico": "špičkový čas",
    "equipment.preparações do dia": "spuštění za den",
    "equipment.Horário": "Čas",
    "equipment.dia selecionado": "vybraný den",
    "equipment.A limpeza adequada e diária do forno auxilia em seu funcionamento correto e impacta na garantia.": "Správné a každodenní čištění trouby přispívá k jejímu správnému fungování a má vliv na záruku.",
    "equipment.Total de limpezas realizadas:": "Celkový počet provedených čištění:",
    "equipment.Limpezas não concluídas:": "Nedokončená čištění:",
    "equipment.Desde a vinculação do forno a IOK": "Od připojení trouby k IOK",
    "equipment.Equipamento ligado há:": "Zařízení je zapnuto již:",
    "equipment.Total de receitas preparadas:": "Celkový počet provedených receptů:",
    "equipment.Receitas preparadas": "Provedené recepty",
    "equipment.Aberturas de porta": "Otevření dveří",
    "equipment.Desde a última vez que o forno foi ligado": "Od posledního zapnutí trouby",
    "equipment.Preparação": "Provedení",
    "equipment.Nenhuma localização criada": "Nebyla vytvořena žádná lokalita",
    "equipment.Acesso remoto": "Vzdálený přístup",
    "equipment.Informe o ID da empresa que poderá acessar remotamente seu forno. Use ; para separar IDs.": "Zadejte ID společnosti, která bude mít vzdálený přístup k vaší troubě. K oddělení ID použijte ;",
    "equipment.O acesso remoto permite que as empresas selecionadas enviem menus e atualizações para seu equipamento.": "Vzdálený přístup umožňuje vybraným společnostem odesílat do vašeho zařízení menu a aktualizace.",
    "equipment.Concedo acesso remoto à Prática oficial.": "Uděluji vzdálený přístup oficiální společnosti Prática.",
    "equipment.Deseja selecionar outros equipamentos vinculados à sua conta para conceder acesso remoto a eles?": "Chcete vybrat další zařízení připojená k vašemu účtu a udělit jim vzdálený přístup?",
    "equipment.Selecione abaixo os equipamentos para os quais deseja conceder acesso remoto à": "Níže vyberte zařízení, kterým chcete udělit vzdálený přístup",
    "equipment.Acesso remoto concedido com sucesso!": "Vzdálený přístup byl úspěšně udělen!",
    "equipment.Selecione pelo menos um equipamento": "Vyberte alespoň jedno zařízení",
    "equipment.Não foi possível editar os equipamentos. Tente novamente mais tarde": "Zařízení nebylo možné upravit. Zkuste to prosím později.",
    "equipment.Solicitar atendimento": "Požádat o servis",
    "equipment.Relate um problema": "Popište problém",
    "equipment.Descreva aqui o problema de seu equipamento": "Popište zde problém svého zařízení",
    "equipment.Não foi possível enviar sua solicitação de atendimento. Tente mais tarde": "Vaši servisní žádost nebylo možné odeslat. Zkuste to prosím později.",
    "equipment.Solicitação técnica enviada com sucesso!": "Technická žádost byla úspěšně odeslána!",
    "equipment.Enviar": "Odeslat",
    "equipment.Solicitação de atendimento": "Servisní požadavek",
    "equipment.Informe o problema de seu equipamento": "Popište problém svého zařízení",
    "equipment.Informações do magnetron": "Informace o magnetronu",
    "equipment.Vida útil aproximada": "Přibližná životnost",
    "equipment.MAGNETRON USAGE HOURS": "Hodiny používání magnetronu",
    "equipment.Atendimento": "Servis",
    "equipment.Eventos mais ocorridos no equipamento durante o período": "Nejčastější události na zařízení během období",
    "equipment.EQUIPAMENTO SEM NÚMERO DE SÉRIE": "ZAŘÍZENÍ BEZ SÉRIOVÉHO ČÍSLA",
    "equipment.Filtros": "Filtry",
    "equipment.Filtrar": "Filtrovat",
    "equipment.Limpar filtros": "Vymazat filtry",
    "equipment.Procurar por modelo, versão ou país": "Hledat podle modelu, verze nebo země",
    "equipment.Procurar equipamento, NS, modelo, versão ou país": "Hledat zařízení, sériové číslo, model, verzi nebo zemi",
    "equipment.Os seguintes IDs não pertencem a uma companhia do tipo 'Distribuidor' e foram removidos": "Následující ID nepatří společnosti typu „Distributor“ a byla odstraněna",
    "equipment.BAIXAR VERSÕES": "STÁHNOUT VERZE",
    "equipment.Compatível com todas as versões da IHM.": "Kompatibilní se všemi verzemi IHM.",
    "equipment.Compatível apenas com a versão 2.0.0C da Power.": "Kompatibilní pouze s verzí Power 2.0.0C.",
    "equipment.Procurar evento": "Hledat událost",
    "equipment.Forno conectado": "Připojená trouba",
    "equipment.Limpeza de filtro de ar": "Čištění vzduchového filtru",
    "equipment.Limpeza de filtro catalítico": "Čištění katalytického filtru",
    "equipment.Limpeza realizada": "Provedené čištění",
    "equipment.Limpeza recomendada": "Doporučené čištění",
    "equipment.Forno ligado": "Trouba zapnuta",
    "equipment.Inversor de frequência": "Frekvenční měnič",
    "equipment.Temperatura de painel": "Teplota panelu",
    "equipment.Sensor da câmara": "Senzor komory",
    "equipment.Magnetron": "Magnetron",
    "equipment.Power": "Napájení",
    "equipment.Informações de menu": "Informace o menu",
    "equipment.Limpeza": "Čištění",
    "equipment.O equipamento já está utilizando a versão mais recente do software.": "Zařízení již používá nejnovější verzi softwaru.",
    "equipment.Atenção: o cálculo da vida útil do magnetron não considera o tempo de uso anterior à versão F1.1.0.": "Pozor: výpočet životnosti magnetronu nezohledňuje dobu používání před verzí F1.1.0.",
    "equipment.Equipamentos com erro": "Zařízení s chybou",
    "equipment.Em breve você terá acesso a dados importantes enviados pelo forno, como horário de pico, receitas mais executadas, histórico de higienizações, eventos ocorridos e mais! Lembre-se de manter seu equipamento sempre atualizado com as novas versões disponíveis na plataforma.": "Brzy budete mít přístup k důležitým údajům odesílaným troubou, jako jsou špičkové časy používání, nejčastěji spouštěné recepty, historie čištění, zaznamenané události a další! Nezapomeňte své zařízení udržovat aktuální pomocí nejnovějších verzí dostupných na platformě.",
    "equipment.Para que a execução da limpeza seja registrada no equipamento e enviada à plataforma, é necessário seguir o passo a passo completo do procedimento no forno. Não é obrigatório assistir aos vídeos dos passos, quando disponíveis.": "Aby bylo provedení čištění zaznamenáno v zařízení a odesláno na platformu, je nutné projít celý postup čištění krok za krokem přímo na troubě. Pokud jsou k dispozici videa k jednotlivým krokům, jejich sledování není povinné.",
    "equipment.Horas de uso": "Hodiny používání",
    "equipment.A contagem das horas de uso do magnetron são realizadas a partir da versão F1.0.6": "Počet hodin používání magnetronu se zaznamenává od verze F1.0.6.",
    "equipment.A atualização do software leva cerca de 15 minutos. Durante o processo, o forno reiniciará e exibirá uma tela azul até a conclusão. Para evitar falhas, mantenha-o ligado e conectado à internet. Caso opte por atualizar via pen drive, não o remova até a conclusão.": "Aktualizace softwaru trvá přibližně 15 minut. Během procesu se trouba restartuje a až do dokončení bude zobrazovat modrou obrazovku. Aby nedošlo k chybám, ponechte ji zapnutou a připojenou k internetu. Pokud se rozhodnete aktualizovat pomocí USB disku, neodpojujte jej až do dokončení.",
    'equipment.Equipamento {name} com software {version} devem ser atualizador via USB. A atualização do software leva cerca de 15 minutos. Durante o processo, o forno reiniciará e exibirá uma tela azul até a conclusão. Para evitar falhas, mantenha-o ligado e conectado à internet. Caso opte por atualizar via pen drive, não o remova até a conclusão.': "Zařízení {name} se softwarem {version} musí být aktualizováno přes USB. Aktualizace softwaru trvá přibližně 15 minut. Během procesu se trouba restartuje a až do dokončení bude zobrazovat modrou obrazovku. Aby nedošlo k chybám, ponechte ji zapnutou a připojenou k internetu. Pokud se rozhodnete aktualizovat pomocí USB disku, neodpojujte jej až do dokončení.",
    "equipment.Observação": "Poznámka:",
    "equipment.Para versões ST2.0.0 e superiores, o envio de atualização pela plataforma (Wi-fi) seguirá disponibilizado normalmente.": "Pro verze ST2.0.0 a vyšší bude odesílání aktualizací prostřednictvím platformy (Wi-Fi) i nadále běžně dostupné.",
    "equipment.Aqui você encontra informações gerais sobre o equipamento;": "Zde naleznete obecné informace o zařízení;",
    "equipment.Ao clicar nestes botões você consegue solicitar atendimento para seu forno e exportar seus dados em planilhas do Excel;": "Kliknutím na tato tlačítka můžete požádat o servis trouby a exportovat data do tabulek Excelu;",
    "equipment.Nos quadros abaixo você encontra informações detalhadas sobre execuções de receitas;": "V níže uvedených sekcích naleznete podrobné informace o provedených receptech;",
    "equipment.Horário de pico;": "Špičková doba používání;",
    "equipment.Informações referentes a higienização;": "Informace týkající se čištění;",
    "equipment.E histórico de eventos;": "A historii událostí;",
    "equipment.Lembre-se de que é necessário selecionar o período do qual deseja visualizar os dados. É possível fazer isso ao clicar sobre o calendário dos quadros e ao selecionar filtros.": "Nezapomeňte vybrat období, za které chcete zobrazit data. To lze provést kliknutím na kalendář v jednotlivých sekcích a použitím filtrů.",
    "equipment.Baixando o arquivo... Ele estará disponível em breve!": "Soubor se stahuje... Brzy bude k dispozici!",
    "equipment.A contagem das horas de uso do magnetron são realizadas a partir da versão F1.1.0": "Počet hodin používání magnetronu se zaznamenává od verze F1.1.0.",
    "equipment.Data de fabricação": "Datum výroby",
    "equipment.manutenção": "údržba",
    "equipment.Ao buscar e localizar um número de série, será aberto um canal temporário diretamente com o forno, permitindo o compartilhamento de seus dados de manutenção. Esses dados não serão armazenados na plataforma, sendo necessário realizar uma nova busca sempre que desejado.": "Po vyhledání a nalezení sériového čísla bude otevřeno dočasné spojení přímo s troubou, které umožní sdílení jejích servisních dat. Tato data nebudou na platformě ukládána, proto bude při každém dalším přístupu nutné vyhledávání zopakovat.",
    "equipment.INFORME UM NÚMERO DE SÉRIE E CLIQUE EM BUSCAR": "ZADEJTE SÉRIOVÉ ČÍSLO A KLIKNĚTE NA HLEDAT",
    "equipment.Apenas os modelos FIT Express / FIT Single Mag / FIT XL com a versão de software F2.1.0 enviarão dados de manutenção. As informações, principalmente as dos contadores, serão contabilizadas a partir dessa versão.": "Pouze modely FIT Express / FIT Single Mag / FIT XL se softwarem verze F2.1.0 budou odesílat servisní data. Informace, zejména údaje z počítadel, budou zaznamenávány od této verze.",
    "equipment.Procurar número de série": "Hledat sériové číslo",
    "equipment.ENCERRAR SESSÃO": "UKONČIT RELACI",
    "equipment.Alerta": "Upozornění",
    "equipment.Local": "Místo",
    "equipment.Software": "Software",
    "equipment.Forno sem limpeza há": "Trouba nebyla čištěna již",
    "equipment.Horário de pico": "Špičková doba používání",
    "equipment.HP": "ŠP",
    "equipment.RECIPE STARTED": "Recept spuštěn",
    "equipment.RECIPE CANCELED": "Recept zrušen uživatelem",
    "equipment.RECIPE COMPLETED": "Recept úspěšně dokončen",
    "equipment.DOOR OPENED RECIPE": "Dveře otevřeny během receptu",
    "equipment.DOOR CLOSED RECIPE": "Dveře zavřeny během receptu",
    "equipment.Receitas iniciadas": "Spuštěné recepty",
    "equipment.Receitas concluídas": "Dokončené recepty",
    "equipment.Receitas interrompidas": "Přerušené recepty",
    "equipment.Total de receitas concluídas:": "Celkový počet dokončených receptů:",
    "equipment.TOTAL DE RECEITAS INTERROMPIDAS": "CELKOVÝ POČET PŘERUŠENÝCH RECEPTŮ",
    "equipment.DOWNLOAD_PROGRESS": "STAHOVÁNÍ SOUBORU... ČEKEJTE, PRŮBĚH: {progress}%",
    "equipment.Informe o número de série do forno": "Zadejte sériové číslo trouby",
    "equipment.preencha o número de série do forno": "Vyplňte sériové číslo trouby",
    "equipment.NÚMERO DE SÉRIE NÃO CADASTRADO": "SÉRIOVÉ ČÍSLO NENÍ REGISTROVÁNO",
    "equipment.Número de série não encontrado. Por favor, verifique e tente novamente": "Sériové číslo nebylo nalezeno. Zkontrolujte jej a zkuste to znovu.",
    "equipment.Antes de iniciar a atualização, faça o backup das receitas salvas no equipamento para garantir a integridade dos dados. O backup pode ser feito via pen drive ou pela plataforma. Isso permite a recuperação das informações em caso de perda.": "Před zahájením aktualizace vytvořte zálohu receptů uložených v zařízení, aby byla zajištěna integrita dat. Zálohu lze provést pomocí USB disku nebo prostřednictvím platformy. To umožní obnovu informací v případě jejich ztráty.",
    "equipment.MENU RECEIVED FROM THE PLATFORM BY FORCED METHOD": "Menu přijato z platformy pomocí vynucené aktualizace",
    "equipment.Nome da receita não encontrado": "Název receptu nebyl nalezen",
    "equipment.passos": "{count, plural, one {krok} other {kroky}}",
    "equipment.minAbbreviation": "min",
    "equipment.secAbbreviation": "s",
    "equipment.Configurações": "Nastavení",
    "equipment.Tempo de preaquecimento": "Doba předehřevu",
    "equipment.Formato de data": "Formát data",
    "equipment.Formato de hora": "Formát času",
    "equipment.Unidade de temperatura": "Jednotka teploty",
    "equipment.Aquecer/dourar mais": "Více ohřát/opéct",
    "equipment.Fabricante": "Výrobce",
    "equipment.Voltagem": "Napětí",
    "equipment.Introdução": "Úvod",
    "equipment.Modelo": "Model",
    "equipment.Motor": "Motor",
    "equipment.Hostname": "Hostname",
    "equipment.STATUS DA OPERAÇÃO": "STAV PROVOZU",
    "equipment.ÚLTIMA LIMPEZA": "POSLEDNÍ ČIŠTĚNÍ",
    "equipment.VELOCIDADE DO MOTOR": "RYCHLOST MOTORU",
    "equipment.TENSÃO ATUAL": "AKTUÁLNÍ NAPĚTÍ",
    "equipment.Sensores e periféricos": "Senzory a periferie",
    "equipment.Contadores": "Počítadla",
    "equipment.HORAS DE USO DO MOTOR": "HODINY PROVOZU MOTORU",
    "equipment.HORAS DE USO DO MAGNETRON": "HODINY PROVOZU MAGNETRONU",
    "equipment.ABERTURAS DE PORTA": "OTEVŘENÍ DVEŘÍ",
    "equipment.ATUAÇÃO DO RELE DA POWER": "AKTIVACE RELÉ NAPÁJENÍ",
    "equipment.ATUAÇÃO DO SENSOR DE PORTA": "AKTIVACE DVEŘNÍHO SENZORU",
    "equipment.RECEITAS EXECUTADAS": "PROVEDENÉ RECEPTY",
    "equipment.LIMPEZAS EXECUTADAS": "PROVEDENÁ ČIŠTĚNÍ",
    "equipment.HORAS DE USO DO FILTRO CATALÍTICO": "HODINY PROVOZU KATALYTICKÉHO FILTRU",
    "equipment.HORAS DE USO DO FILTRO DE AR": "HODINY PROVOZU VZDUCHOVÉHO FILTRU",
    "equipment.CORRENTE DO MAGNETRON": "PROUD MAGNETRONU",
    "equipment.Erros": "Chyby",
    "equipment.status online": "online stav",
    "equipment.status offline": "offline stav",
    "equipment.software accepted": "software přijat",
    "equipment.menu accepted": "menu přijato",
    "equipment.software pending": "software čeká na potvrzení",
    "equipment.menu pending": "menu čeká na potvrzení",
    "equipment.software refused": "software odmítnut",
    "equipment.menu refused": "menu odmítnuto",
    "equipment.Ativado": "Aktivováno",
    "equipment.Desativado": "Deaktivováno",
    "equipment.Cozinhando": "Vaření",
    "equipment.Pré-aquecendo": "Předehřívání",
    "equipment.Em espera": "Pohotovostní režim",
    "equipment.Limpando": "Čištění",
    "equipment.horas": "hodiny",
    "equipment.Erro CAN": "Chyba CAN",
    "equipment.Erro no sensor de câmara": "Chyba senzoru komory",
    "equipment.Alerta de temperatura alta no painel": "Upozornění na vysokou teplotu panelu",
    "equipment.Erro de temperatura alta no painel": "Chyba vysoké teploty panelu",
    "equipment.Alerta de comunicação no inversor de frequência": "Upozornění na komunikaci frekvenčního měniče",
    "equipment.Alerta de status no inversor de frequência": "Upozornění na stav frekvenčního měniče",
    "equipment.Alerta na corrente do magnetron": "Upozornění na proud magnetronu",
    "equipment.Erro no modelo do equipamento": "Chyba modelu zařízení",
    "equipment.Erro no módulo de energia": "Chyba energetického modulu",
    "equipment.Erro I2C": "Chyba I2C",
    "equipment.Erro de temperatura alta na placa": "Chyba vysoké teploty desky",
    "equipment.Fechado": "Zavřeno",
    "equipment.Aberto": "Otevřeno",
    "equipment.Câmara": "Komora",
    "equipment.Placa": "Deska",
    "equipment.Tensão": "Napětí",
    "equipment.Corrente da placa": "Proud desky",
    "equipment.Velocidade do motor": "Rychlost motoru",
    "equipment.Rele da resistência": "Relé topného tělesa",
    "equipment.Rele de curto circuito": "Relé zkratu",
    "equipment.Ventilador radial": "Radiální ventilátor",
    "equipment.Led vermelho": "Červená LED",
    "equipment.Led verde": "Zelená LED",
    "equipment.Led azul": "Modrá LED",
    "equipment.Erro": "Chyba",
    "equipment.Sensor": "Senzor",
    "equipment.Valor": "Hodnota",
    "equipment.Manutenção da temperatura": "Udržování teploty",
    "equipment.Manutenção": "Údržba",
    "equipment.Esfriando": "Ochlazování",
    "equipment.CEILING SENSOR ERROR": "Chyba stropního senzoru",
    "equipment.BALLAST SENSOR ERROR": "Chyba senzoru pečicí desky",
    "equipment.VAPORIZER SENSOR ERROR": "Chyba senzoru zvlhčovače",
    "equipment.EQUIPMENT CONSUMPTION": "Spotřeba",
    "equipment.Sensores": "Senzory",
    "equipment.Falta de água": "Nedostatek vody",
    "equipment.Executando Receita": "Probíhá recept",
    "equipment.Executando Limpeza": "Probíhá čištění",
    "equipment.Dia": "Den",
    "equipment.Semana": "Týden",
    "equipment.Mês": "Měsíc",
    "equipment.Tempo": "Čas",
    "equipment.Segunda": "Pondělí",
    "equipment.Terça": "Úterý",
    "equipment.Quarta": "Středa",
    "equipment.Quinta": "Čtvrtek",
    "equipment.Sexta": "Pátek",
    "equipment.Sábado": "Sobota",
    "equipment.Domingo": "Neděle",
    "equipment.CONSUMO ESTIMADO": "ODHADOVANÁ SPOTŘEBA",
    "equipment.CONSUMO ATUAL": "AKTUÁLNÍ SPOTŘEBA",
    "equipment.ECONOMIA COM MODO ECO": "ÚSPORA V REŽIMU ECO",
    "equipment.MÉDIA SEMANAL": "TÝDENNÍ PRŮMĚR",
    "equipment.MÉDIA MENSAL": "MĚSÍČNÍ PRŮMĚR",
    "equipment.Consumo de energia": "Spotřeba energie",
    "equipment.CONSUMO ACUMULADO": "KUMULOVANÁ SPOTŘEBA",
    "equipment.MÉDIA DIÁRIA": "DENNÍ PRŮMĚR",
    "equipment.mês selecionado": "vybraný měsíc",
    "equipment.Este valor representa a soma total dos consumos de cada hora do dia.": "Tato hodnota představuje celkový součet spotřeby za každou hodinu dne.",
    "equipment.Este valor representa a soma total dos consumos de cada dia.": "Tato hodnota představuje celkový součet spotřeby za každý den.",
    "equipment.Este valor representa a soma total dos consumos de cada semana.": "Tato hodnota představuje celkový součet spotřeby za každý týden.",
    "equipment.Este valor representa a soma total dos consumos de cada mês.": "Tato hodnota představuje celkový součet spotřeby za každý měsíc.",
    "equipment.Este valor representa a média do consumo das horas, apresentando assim uma estimativa baseada em seu uso.": "Tato hodnota představuje průměrnou hodinovou spotřebu a poskytuje odhad založený na vašem používání.",
    "equipment.Este valor representa a média do consumo de cada dia, apresentando assim uma estimativa baseada em seu uso.": "Tato hodnota představuje průměrnou denní spotřebu a poskytuje odhad založený na vašem používání.",
    "equipment.Este valor representa a média do consumo semanal, apresentando assim uma estimativa baseada em seu uso.": "Tato hodnota představuje průměrnou týdenní spotřebu a poskytuje odhad založený na vašem používání.",
    "equipment.Este valor representa a média do consumo dos últimos dois meses, apresentando assim uma estimativa baseada em seu uso.": "Tato hodnota představuje průměrnou spotřebu za poslední dva měsíce a poskytuje odhad založený na vašem používání.",
    "equipment.Este valor representa a soma total da economia de consumo de cada hora do dia com a utilização do modo Eco.": "Tato hodnota představuje celkovou úsporu spotřeby za každou hodinu dne při použití režimu Eco.",
    "equipment.Este valor representa a soma total da economia de consumo de cada dia com a utilização do modo Eco.": "Tato hodnota představuje celkovou úsporu spotřeby za každý den při použití režimu Eco.",
    "equipment.Este valor representa a soma total da economia de consumo semanal com a utilização do modo Eco.": "Tato hodnota představuje celkovou týdenní úsporu spotřeby při použití režimu Eco.",
    "equipment.Este valor representa a soma total da economia de consumo mensal com a utilização do modo Eco.": "Tato hodnota představuje celkovou měsíční úsporu spotřeby při použití režimu Eco.",
    "equipment.Este valor representa a média de consumo dos últimos 7 dias, desconsiderando o dia atual.": "Tato hodnota představuje průměrnou spotřebu za posledních 7 dní, bez započítání dnešního dne.",
    "equipment.Este valor representa a média de consumo das últimas 4 semanas.": "Tato hodnota představuje průměrnou spotřebu za poslední 4 týdny.",
    "equipment.Este valor representa a média de consumo dos últimos 2 meses, desconsiderando o mês atual.": "Tato hodnota představuje průměrnou spotřebu za poslední 2 měsíce, bez započítání aktuálního měsíce.",
    "equipment.Lista de consumo de energia": "Seznam spotřeby energie",
    "equipment.Período": "Období",
    "equipment.Consumo (kWh)": "Spotřeba (kWh)",
    "equipment.Economia com ECO (kWh)": "Úspora s ECO (kWh)",
    "equipment.Total": "Celkem",
    "equipment.Sensor de RI": "Senzor RI",
    "equipment.HUMIDITY SENSOR ERROR": "Chyba senzoru vlhkosti",
    "equipment.TEMPERATURE SENSOR ERROR": "Chyba teplotního senzoru",
    "equipment.WATER FILTER CLEANING COMPLETED": "Výměna vodního filtru dokončena",
    "equipment.WATER FILTER CLEANING REJECTED": "Výměna vodního filtru odmítnuta",
    "equipment.HOOD TURNED ON": "Digestoř zapnuta",
    "equipment.HOOD TURNED OFF": "Digestoř vypnuta",
    "equipment.AUTOMATIC PREHEATING REJECTED": "Automatický předehřev odmítnut",
    "equipment.Receitas Forno": "Recepty trouby",
    "equipment.Receitas Fermentadora": "Recepty kynárny",
    "equipment.média diária": "denní průměr",
    "equipment.média de execução diária": "průměrný denní počet spuštění",
    "equipment.FERMENTADORA": "KYNÁRNA",
    "equipment.FORNO": "TROUBA",
    "equipment.DIA": "DEN",
    "equipment.Baixado": "Staženo",
    "equipment.A limpeza diária do equipamento auxilia em seu bom funcionamento e impacta na garantia.": "Každodenní čištění zařízení přispívá k jeho správnému fungování a má vliv na záruku.",
    "equipment.Desde a vinculação do equipamento ao IOK": "Od propojení zařízení s IOK",
    "equipment.Total desde a vinculação do equipamento ao IOK": "Celkem od propojení zařízení s IOK",
    "equipment.Receitas do forno": "Recepty trouby",
    "equipment.Receitas da fermentadora": "Recepty kynárny",
    "equipment.FERM.": "KYN.",
    "equipment.Fermentadora": "Kynárna",
    "equipment.Coifa": "Digestoř",
    "equipment.Preaquecimento automático": "Automatický předehřev",
    "equipment.nivel": "úroveň",
    "equipment.Fermentadora ligada": "Kynárna zapnuta",
    "equipment.Fermentadora desligada": "Kynárna vypnuta",
    "equipment.Forno desligado": "Trouba vypnuta",
    "equipment.Equipamento ligado": "Zařízení zapnuto",
    "equipment.Equipamento desligado": "Zařízení vypnuto",
    "equipment.visualizar haccp": "zobrazit HACCP",
    "equipment.HACCP": "HACCP",
    "equipment.Atualizar Equip.": "Aktualizovat zařízení",
    "equipment.Consumo de agua por receita": "Spotřeba vody na recept",
    "equipment.Consumo de energia por receita": "Spotřeba energie na recept",
    "equipment.AINDA NAO HA DADOS DE CONSUMO DE AGUA POR RECEITA :(": "ZATÍM NEJSOU K DISPOZICI ŽÁDNÁ DATA O SPOTŘEBĚ VODY NA RECEPT :(",
    "equipment.AINDA NAO HA DADOS DE CONSUMO DE ENERGIA POR RECEITA :(": "ZATÍM NEJSOU K DISPOZICI ŽÁDNÁ DATA O SPOTŘEBĚ ENERGIE NA RECEPT :(",
    "equipment.LITROS CONSUMIDOS NO DIA": "LITRY SPOTŘEBOVANÉ ZA DEN",
    "equipment.ENERGIA CONSUMIDA NO DIA": "ENERGIE SPOTŘEBOVANÁ ZA DEN",
    "equipment.CONSUMO ACUMULADO SEMANAL": "KUMULOVANÁ TÝDENNÍ SPOTŘEBA",
    "equipment.CONSUMO ACUMULADO MENSAL": "KUMULOVANÁ MĚSÍČNÍ SPOTŘEBA",
    "equipment.Receitas": "Recepty",
    "equipment.Consumo (L)": "Spotřeba (L)",
    "equipment.Exec. dia - (L)": "Provedení za den - (L)",
    "equipment.Exec. semana - (L)": "Provedení za týden - (L)",
    "equipment.Exec. mês - (L)": "Provedení za měsíc - (L)",
    "equipment.Exec. dia - (kWh)": "Provedení za den - (kWh)",
    "equipment.Exec. semana - (kWh)": "Provedení za týden - (kWh)",
    "equipment.Exec. mês - (kWh)": "Provedení za měsíc - (kWh)",
    "equipment.Agua consumida (litros)": "Spotřebovaná voda (litry)",
    "equipment.Energia consumida (kWh)": "Spotřebovaná energie (kWh)",
    "equipment.temperatura da câmara": "Teplota komory",
    "equipment.temperatura do vapor": "Teplota páry",
    "equipment.último evento listado": "Poslední uvedená událost",
    "equipment.temperatura da sonda": "Teplota sondy",
    "equipment.porta": "Dveře",
    "equipment.temperatura": "Teplota",
    "equipment.temperatura atual": "Aktuální teplota",
    "equipment.média de oscilação diária": "Průměrná denní odchylka",
    "equipment.oscilação diária da temperatura": "Denní kolísání teploty",
    "equipment.temperature.sectionTitle": "Teplota",
    "equipment.temperature.currentChamber": "AKTUÁLNÍ TEPLOTA KOMORY:",
    "equipment.temperature.currentProbe": "AKTUÁLNÍ TEPLOTA SONDY:",
    "equipment.temperature.currentSteam": "AKTUÁLNÍ TEPLOTA PÁRY:",
    "equipment.temperature.dailyOscillation": "Denní kolísání teploty",
    "equipment.temperature.chamberShort": "Komora",
    "equipment.temperature.probeShort": "Sonda",
    "equipment.temperature.axisLabel": "Teplota {unit}",
    "equipment.temperature.dailyAverage": "DENNÍ PRŮMĚR",
    "equipment.temperature.weeklyAverage": "TÝDENNÍ PRŮMĚR",
    "equipment.temperature.monthlyAverage": "MĚSÍČNÍ PRŮMĚR",
    "equipment.temperature.lastListedEvent": "Poslední uvedená událost",
    "equipment.temperature.door": "Dveře",
    "equipment.temperature.open": "OTEVŘENÉ",
    "equipment.temperature.closed": "ZAVŘENÉ",
    "equipment.temperature.defineTimeRange": "Definovat časový interval:",
    "equipment.temperature.until": "v",
    "equipment.cleaningType.smart": "Inteligentní čištění",
    "equipment.cleaningType.light": "Lehké čištění",
    "equipment.cleaningType.medium": "Střední čištění",
    "equipment.cleaningType.heavy": "Intenzivní čištění",
    "equipment.cleaningType.decalcifying": "Odvápňovací čištění",
    "equipment.cleaningType.security": "Bezpečnostní čištění",
    "equipment.cleaningType.rinse": "Oplach",
    "equipment.cleaningType.custom": "Vlastní čištění",
    "equipment.cleaningTypeShort.smart": "Inteligentní",
    "equipment.cleaningTypeShort.light": "Lehké",
    "equipment.cleaningTypeShort.medium": "Střední",
    "equipment.cleaningTypeShort.heavy": "Intenzivní",
    "equipment.cleaningTypeShort.decalcifying": "Odvápnění",
    "equipment.cleaningTypeShort.security": "Bezpečnost",
    "equipment.cleaningTypeShort.rinse": "Oplach",
    "equipment.cleaningTypeShort.custom": "Vlastní",
    "equipment.gerar gráficos": "generovat grafy",
    "equipment.Realizada": "Provedeno",
    "equipment.Recomendada": "Doporuč.",
    "equipment.Dias da semana": "Dny v týdnu",
    "equipment.Horário 24h": "24hodinový čas",
    "equipment.seg": "Po",
    "equipment.ter": "Út",
    "equipment.qua": "St",
    "equipment.qui": "Čt",
    "equipment.sex": "Pá",
    "equipment.sab": "So",
    "equipment.dom": "Ne",
    "equipment.Desconhecido": "Neznámé",
    "equipment.AINDA NÃO HÁ DADOS DE CONSUMO DE ENERGIA AQUI :(": "ZATÍM ZDE NEJSOU K DISPOZICI ŽÁDNÁ DATA O SPOTŘEBĚ ENERGIE :(",
    "equipment.monthShort.Jan": "Led",
    "equipment.monthShort.Fev": "Úno",
    "equipment.monthShort.Mar": "Bře",
    "equipment.monthShort.Abr": "Dub",
    "equipment.monthShort.Mai": "Kvě",
    "equipment.monthShort.Jun": "Čvn",
    "equipment.monthShort.Jul": "Čvc",
    "equipment.monthShort.Ago": "Srp",
    "equipment.monthShort.Set": "Zář",
    "equipment.monthShort.Out": "Říj",
    "equipment.monthShort.Nov": "Lis",
    "equipment.monthShort.Dez": "Pro",
    "equipment.settingsChange.category": "Změna parametrů",
    "equipment.settingsChange.factoryTitle": "Změna technického parametru",
    "equipment.settingsChange.userTitle": "Změna uživatelského parametru",
    "equipment.settingsChange.changedTo": "{label} změněno na {value}",
    "equipment.settingsChange.hardResetExecuted": "Byl proveden hard reset",
    "equipment.settingsChange.userFactoryResetExecuted": "Bylo provedeno obnovení továrního nastavení uživatele",
    "equipment.settingsChange.magSensorEnabled": "magnetronový senzor",
    "equipment.settingsChange.serialNumber": "sériové číslo",
    "equipment.settingsChange.manufactureDate": "datum výroby",
    "equipment.settingsChange.inverterType": "typ měniče",
    "equipment.settingsChange.preHeatMotorSpeed": "rychlost motoru předehřevu",
    "equipment.settingsChange.voltage": "napětí",
    "equipment.settingsChange.oemModeEnabled": "režim OEM",
    "equipment.settingsChange.controlDoor": "ovládání dveří",
    "equipment.settingsChange.hardReset": "hard reset",
    "equipment.settingsChange.preHeatTemperatureOne": "teplota předehřevu 1",
    "equipment.settingsChange.preHeatTemperatureTwo": "teplota předehřevu 2",
    "equipment.settingsChange.preHeatTime": "doba předehřevu",
    "equipment.settingsChange.preHeatTwoEnabled": "předehřev 2",
    "equipment.settingsChange.userFactoryReset": "obnovení továrního nastavení uživatele",
    "equipment.settingsChange.enableManualMode": "manuální režim",
    "equipment.settingsChange.enableFavorites": "oblíbené",
    "equipment.settingsChange.enableHeatBrown": "intenzivnější ohřev/zapečení",
    "equipment.settingsChange.enableRepeatRecipe": "opakovat recept",
    "equipment.settingsChange.enableOperatorMode": "režim operátora",
    "equipment.settingsChange.enableAutoImport": "automatický import",
    "equipment.settingsChange.enableRecipePreRunMessage": "zpráva před přípravou receptu",
    "equipment.settingsChange.controlDoorTwoInputs": "2 vstupy",
    "equipment.settingsChange.controlDoorThreeInputs": "3 vstupy",

    //LOJAS
    "store.Procurar loja": "Hledat prodejnu",
    "store.Excluir": "Smazat",
    "store.Editar": "Upravit",
    "store.nome": "Název",
    "store.equipamentos": "Zařízení",
    "store.Equipamentos vinculados": "Propojená zařízení",
    "store.cidade": "Město",
    "store.estado": "Stát",
    "store.salvar": "uložit",
    "store.cadastrar loja": "registrovat prodejnu",
    "store.Nome fantasia": "Obchodní název",
    "store.Preencha o nome da loja": "Vyplňte název prodejny",
    "store.CNPJ": "CNPJ",
    "store.Preencha o CNPJ da loja": "Vyplňte CNPJ prodejny",
    "store.CEP": "PSČ",
    "store.Preencha o CEP da loja": "Vyplňte PSČ prodejny",
    "store.Informe o nome fantasia": "Zadejte obchodní název",
    "store.Cidade": "Město",
    "store.Informe a cidade": "Zadejte město",
    "store.Preencha a cidade": "Vyplňte město",
    "store.UF": "Stát",
    "store.Preencha o UF da loja": "Vyplňte stát prodejny",
    "store.Bairro": "Čtvrť",
    "store.Informe o bairro": "Zadejte čtvrť",
    "store.Preencha o bairro da loja": "Vyplňte čtvrť prodejny",
    "store.Endereço": "Adresa",
    "store.Informe o endereço": "Zadejte adresu",
    "store.Preencha o endereço da loja": "Vyplňte adresu prodejny",
    "store.Nº": "Č.",
    "store.Preencha o número": "Vyplňte číslo",
    "store.Loja cadastrada com sucesso": "Prodejna byla úspěšně zaregistrována",
    "store.Erro ao adicionar loja. Tente novamente": "Chyba při přidávání prodejny. Zkuste to znovu",
    "store.Loja deletada com sucesso": "Prodejna byla úspěšně smazána",
    "store.Erro ao deletar loja. Tente novamente mais tarde": "Chyba při mazání prodejny. Zkuste to znovu později",
    "store.AINDA NÃO HÁ NENHUMA LOJA CADASTRADA :(": "ZATÍM NENÍ ZAREGISTROVÁNA ŽÁDNÁ PRODEJNA :(",
    "store.EXCLUIR LOJA": "SMAZAT PRODEJNU",
    "store.Você deseja excluir a loja da plataforma IOK?": "Opravdu chcete odstranit prodejnu z platformy IOK?",
    "store.Ao fazer isso, os equipamentos atrelados à ela não terão vínculo com nenhuma loja, a menos que os vincule novamente.": "Po provedení této akce nebudou zařízení přiřazena k žádné prodejně, dokud je znovu nepřiřadíte.",
    "store.loja editada com sucesso": "Prodejna byla úspěšně upravena",
    "store.não foi possível editar a loja. Tente novamente mais tarde": "Nepodařilo se upravit prodejnu. Zkuste to znovu později",
    "store.editar loja": "upravit prodejnu",
    "store.Procurar grupo de equipamentos": "Hledat skupinu zařízení",
    "store.cadastrar grupo": "registrovat skupinu",
    "store.AINDA NÃO HÁ NENHUM GRUPO CADASTRADO :(": "ZATÍM NENÍ ZAREGISTROVÁNA ŽÁDNÁ SKUPINA :(",
    "store.description.AINDA NÃO HÁ NENHUM GRUPO CADASTRADO :(": "Klikněte na tlačítko v pravém horním rohu a přidejte skupiny.",
    "store.cadastrar grupo de equipamentos": "registrovat skupinu zařízení",
    "store.grupo de equipamentos cadastrado com sucesso!": "Skupina zařízení byla úspěšně zaregistrována!",
    "store.não foi possível cadastrar o grupo. Tente novamente mais tarde": "Nepodařilo se zaregistrovat skupinu. Zkuste to znovu později",
    "store.Nome do grupo": "Název skupiny",
    "store.informe o nome do grupo": "Zadejte název skupiny",
    "store.preencha o nome do grupo": "Vyplňte název skupiny",
    "store.Grupo de equipamentos deletado com sucesso!": "Skupina zařízení byla úspěšně smazána!",
    "store.Erro ao deletar o grupo. Tente novamente mais tarde": "Chyba při mazání skupiny. Zkuste to znovu později",
    "store.EXCLUIR GRUPO DE EQUIPAMENTOS": "SMAZAT SKUPINU ZAŘÍZENÍ",
    "store.Você deseja excluir este grupo de equipamentos da plataforma IOK?": "Opravdu chcete odstranit tuto skupinu zařízení z platformy IOK?",
    "store.Ao fazer isso, os equipamentos atrelados à ele não terão vínculo com nenhum grupo, a menos que os vincule novamente.": "Po provedení této akce nebudou zařízení přiřazena k žádné skupině, dokud je znovu nepřiřadíte.",
    "store.grupo de equipamentos editado com sucesso!": "Skupina zařízení byla úspěšně upravena!",
    "store.não foi possível editar o grupo. Tente novamente mais tarde": "Nepodařilo se upravit skupinu. Zkuste to znovu později",
    "store.editar grupo de equipamentos": "upravit skupinu zařízení",
    "store.CEP não encontrado no Brasil": "PSČ nebylo v Brazílii nalezeno",
    "store.Cadastrar": "Registrovat",
    
    // NAVBAR
    "navbar.home": "Domů",
    "navbar.cookbook": "Kuchařka",
    "navbar.my menus": "Moje menu",
    "navbar.equipment": "Zařízení",
    "navbar.users": "Uživatelé",
    "navbar.calls": "Servisní požadavky",
    "navbar.settings": "Nastavení",
    "navbar.help": "Nápověda",
    "navbar.logout": "Odhlásit se",
    "navbar.Editar conta": "Upravit účet",
    "navbar.API Externa": "Externí API",
    "navbar.companhias": "Společnosti",
    "navbar.information": "Informace o IOK",

    // FOOTERBAR
    "footerBar.menu": "Menu",
    "footerBar.cookbook": "Kuchařka",
    "footerBar.home": "Domů",
    "footerBar.menus": "Menu",
    "footerBar.notifications": "Oznámení",

    //MAP
    "map.título": "Poloha",
    "map.erro": "chyba!",
    "map.mensagem de erro": "mapu se nepodařilo načíst.",
    "map.Localização não disponível": "Poloha není dostupná",

    //MODAL
    "modal.CONFIRMAR": "POTVRDIT",
    "modal.Salvar alterações": "Uložit změny",
    "Modal.Há alterações não salvas nos parâmetros dos passos ": "V parametrech kroků jsou neuložené změny ",
    "Modal.Como deseja proceder?": "Jak chcete pokračovat?",
    "Modal.Avaliar alterações realizadas": "Zkontrolovat provedené změny",
    "Modal.Descartar alterações": "Zahodit změny",

    //USUÁRIOS
    "user.Nome": "Jméno",
    "user.E-mail": "E-mail",
    "user.Permissão": "Oprávnění",
    "user.Loja": "Prodejna",
    "user.Status": "Stav",
    "user.Excluir": "Smazat",
    "user.Editar": "Upravit",
    "user.Procurar usuário": "Hledat uživatele",
    "user.ADICIONAR USUÁRIO": "PŘIDAT UŽIVATELE",
    "user.AINDA NÃO HÁ NENHUM USUÁRIO CADASTRADO :(": "ZATÍM NENÍ ZAREGISTROVÁN ŽÁDNÝ UŽIVATEL :(",
    "user.+ Usuário": "+ Uživatel",
    "user.Informe o nome do usuário": "Zadejte jméno uživatele",
    "user.Preencha o nome do usuário": "Vyplňte jméno uživatele",
    "user.Informe o e-mail do usuário": "Zadejte e-mail uživatele",
    "user.Preencha com um e-mail válido": "Zadejte platný e-mail",
    "user.Administrador": "Administrátor",
    "user.Usuário": "Uživatel",
    "user.Preencha o telefone do usuário": "Vyplňte telefonní číslo uživatele",
    "user.Selecione a permissão do usuário": "Vyberte oprávnění uživatele",
    "user.Ativo": "Aktivní",
    "user.Inativo": "Neaktivní",
    "user.Usuário deletado da plataforma com sucesso!": "Uživatel byl z platformy úspěšně odstraněn!",
    "user.Ocorreu um erro. Tente novamente mais tarde": "Došlo k chybě. Zkuste to znovu později",
    "user.EXCLUIR USUÁRIO": "SMAZAT UŽIVATELE",
    "user.delete.paragrafo 1": "Opravdu chcete odstranit uživatele z platformy IOK?",
    "user.delete.paragrafo 2": "Po provedení této akce ztratí přístup ke všem nástrojům platformy, dokud nebude znovu přidán podle pokynů pro registraci.",
    "user.EDITAR USUÁRIO": "UPRAVIT UŽIVATELE",
    "user.Usuário editado com sucesso!": "Uživatel byl úspěšně upraven!",
    "user.Não foi possível editar este usuário. Por favor, tente mais tarde": "Tento účet se nepodařilo upravit. Zkuste to prosím později",
    "user.INFORMAÇÕES DO USUÁRIO": "INFORMACE O UŽIVATELI",
    "user.Telefone": "Telefon",
    "user.Não foi possível cadastrar este usuário. Por favor, tente mais tarde": "Tento účet se nepodařilo zaregistrovat. Zkuste to prosím později",
    "user.Usuário adicionado com sucesso!": "Uživatel byl úspěšně přidán!",
    "user.CRIAR TIPO DE USUÁRIO": "VYTVOŘIT TYP UŽIVATELE",
    "user.Criar novo tipo de usuário": "Vytvořit nový typ uživatele",
    "user.Adicionar novo usuário": "Přidat nového uživatele",
    "user.Permissões": "Oprávnění",
    "user.Preencha o nome do novo tipo de usuário": "Vyplňte název nového typu uživatele",
    "user.Selecione pelo menos uma permissão": "Vyberte alespoň jedno oprávnění",
    "user.Não foi possível carregar as permissões": "Nepodařilo se načíst oprávnění",
    "user.Tipo de usuário criado com sucesso!": "Typ uživatele byl úspěšně vytvořen!",
    "user.Não foi possível criar este novo tipo de usuário. Por favor, tente mais tarde": "Nepodařilo se vytvořit nový typ uživatele. Zkuste to prosím později",
    "user.Não foi possível carregar os tipos de usuário da companhia": "Nepodařilo se načíst typy uživatelů společnosti",
    "user.Tipo de usuário": "Typ uživatele",
    "user.E-mail já cadastrado na plataforma. Informe um novo e-mail": "Tento e-mail je již na platformě registrován. Zadejte jiný e-mail",
    "user.UNIR CONTAS": "SLOUČIT ÚČTY",
    "user.ID da companhia": "ID společnosti",
    "user.Digite o ID da companhia que deseja unir a sua conta": "Zadejte ID společnosti, kterou chcete sloučit se svým účtem",
    "user.Preencha o ID da companhia": "Vyplňte ID společnosti",
    "user.O administrador da outra conta poderá localizar o ID ao clicar em seu nome de usuário, localizado no menu superior, no canto direito da tela.": "Administrátor druhého účtu může najít ID kliknutím na své uživatelské jméno v horním menu v pravém rohu obrazovky.",
    "user.O administrador da outra conta receberá um e-mail para aceitar sua solicitação. Assim que for aceita, a união das duas contas será realizada!": "Administrátor druhého účtu obdrží e-mail pro schválení vaší žádosti. Jakmile bude schválena, účty budou sloučeny!",
    "user.Não foi possível solicitar a união de contas. Por favor, confirme o ID ou tente mais tarde": "Nepodařilo se požádat o sloučení účtů. Zkontrolujte ID nebo to zkuste později",
    "user.SOLICITAÇÃO APROVADA COM SUCESSO": "ŽÁDOST BYLA ÚSPĚŠNĚ SCHVÁLENA",
    "user.AGUARDE ENQUANTO REALIZAMOS A UNIÃO DAS CONTAS. ESTE PROCESSO PODE LEVAR ALGUNS MINUTOS...": "ČEKEJTE, PROBÍHÁ SLUČOVÁNÍ ÚČTŮ. TENTO PROCES MŮŽE TRVAT NĚKOLIK MINUT...",
    "user.UNIÃO DE CONTAS FINALIZADA COM SUCESSO! CLIQUE NO BOTÃO ABAIXO PARA ACESSAR A PLATAFORMA.": "SLUČOVÁNÍ ÚČTŮ BYLO ÚSPĚŠNĚ DOKONČENO! KLIKNĚTE NA TLAČÍTKO NÍŽE PRO PŘÍSTUP K PLATFORMĚ.",
    "user.NÃO CONSEGUIMOS REALIZAR A UNIÃO DAS CONTAS. POR FAVOR, TENTE NOVAMENTE. SE O PROBLEMA PERSISTIR, ENTRE EM CONTATO COM NOSSO SUPORTE.": "NEPODAŘILO SE NÁM SLUČIT ÚČTY. ZKUSTE TO PROSÍM ZNOVU. POKUD PROBLÉM PŘETRVÁVÁ, KONTAKTUJTE NAŠI PODPORU.",
    "user.possui todos os acessos": "má všechny přístupy",
    "user.possui o acesso das abas cookbook, meus menus e equipamentos": "má přístup ke Kuchařce, Mým menu a Zařízením",
    "user.possui apenas o acesso da aba cookbook": "má přístup pouze ke Kuchařce",
    "user.possui apenas o acesso da aba equipamentos": "má přístup pouze k Zařízením",
    "user.possui apenas o acesso da aba meus menus": "má přístup pouze k Mým menu",
    "user.Grupo de equipamentos": "Skupina zařízení",
    "user.Informe o telefone do usuário": "Zadejte telefonní číslo uživatele",
    "user.Nenhum grupo criado": "Nebyla vytvořena žádná skupina",
    "user.Digite o ID da companhia que terá acesso à sua conta": "Zadejte ID společnosti, která bude mít přístup k vašemu účtu",
    "user.Ao informar um ID para unir contas com sua companhia, esteja ciente de que o novo usuário também se tornará Administrador da conta de sua companhia. É importante informar que a partir do momento em que um usuário aceitar unir contas com sua companhia, a companhia pertencente a ele deixará de existir.": "Při zadání ID pro sloučení účtů se společností mějte na paměti, že nový uživatel se také stane administrátorem účtu vaší společnosti. Jakmile uživatel přijme sloučení účtů s vaší společností, jeho původní společnost přestane existovat.",
    "user.Exemplo: Sua conta: 001 | Outra conta: 111. Depois de unir contas com você, a outra conta passará a ser 001.": "Příklad: Váš účet: 001 | Jiný účet: 111. Po sloučení bude druhý účet používat ID 001.",
    "user.Tela de Equipamentos": "Obrazovka Zařízení",
    "user.Tela de Meus Menus": "Obrazovka Moje menu",
    "user.Tela do Cookbook": "Obrazovka Kuchařka",
    "user.Tela de Usuários": "Obrazovka Uživatelé",
    "user.Aba de Suporte": "Karta Podpora",
    "user.Usuário Comum": "Běžný uživatel",
    "user.Usuário do Cookbook": "Uživatel Kuchařky",
    "user.Usuário de Equipamentos": "Uživatel zařízení",
    "user.Usuário de Meus Menus": "Uživatel Mých menu",
    "user.Você deseja excluir seu acesso da plataforma IOK?": "Opravdu chcete odstranit svůj přístup k platformě IOK?",
    "user.Ao fazer isso, você perderá o acesso a todas as ferramentas da plataforma e, para voltar a acessá-la, será necessário ser adicionado à ela novamente.": "Po provedení této akce ztratíte přístup ke všem nástrojům platformy a pro opětovný přístup budete muset být znovu přidáni.",
    "user.CONFIRMAÇÃO": "POTVRZENÍ",
    "user.Confirme sua senha": "Potvrďte své heslo",
    "user.Senha incorreta": "Nesprávné heslo",
    "user.Os equipamentos e menus criados por ele serão transferidos para o seu nome.": "Zařízení a menu vytvořená tímto uživatelem budou převedena na vaše jméno.",

    //TUTORIAIS 
    "tutorial.Fechar": "Zavřít",
    "tutorial.Fim": "Konec",
    "tutorial.Próximo": "Další",
    "tutorial.Abrir": "Otevřít",
    "tutorial.Pular tutorial": "Přeskočit tutoriál",
    "tutorial.Editar detalhes da receita": "Upravit podrobnosti receptu",
    "tutorial.Agora você pode adicionar mais detalhes às suas receitas e deixá-las ainda mais completas. Clique em Editar detalhes e preencha as informações necessárias.": "Nyní můžete ke svým receptům přidat více podrobností a udělat je ještě kompletnějšími. Klikněte na Upravit podrobnosti a vyplňte potřebné informace.",
    "tutorial.Salvar edição da receita": "Uložit úpravy receptu",
    "tutorial.Depois de informar mais detalhes da receita, clique em Salvar.": "Po zadání dalších podrobností receptu klikněte na Uložit.",
    "tutorial.Editar registro de um equipamento": "Upravit záznam zařízení",
    "tutorial.Para completar o registro de seus equipamentos, abra o menu lateral, clique em Editar e preencha as informações de Categoria e Loja.": "Pro dokončení registrace zařízení otevřete boční menu, klikněte na Upravit a vyplňte informace o kategorii a prodejně.",
    "tutorial.Editar usuário": "Upravit uživatele",
    "tutorial.Para completar o cadastro dos usuários, abra o menu lateral, clique em Editar e preencha a informação referente a Loja a qual ele faz parte.": "Pro dokončení registrace uživatelů otevřete boční menu, klikněte na Upravit a vyplňte informaci o prodejně, ke které uživatel patří.",
    "tutorial.Salvar edições de um equipamento": "Uložit změny zařízení",
    "tutorial.Depois de completar o registro de seus equipamentos, clique em Salvar.": "Po dokončení registrace zařízení klikněte na Uložit.",
    "tutorial.Ao clicar sobre a linha de um equipamento cadastrado em uma loja, você pode visualizar mais estatísticas e informações sobre ele, além de poder solicitar um atendimento ou disparar atualizações.": "Kliknutím na řádek zařízení registrovaného v prodejně můžete zobrazit více statistik a informací, požádat o servis nebo spustit aktualizace.",
    "tutorial.Para visualizar mais informações sobre a loja, como localização e receitas mais preparadas, clique sobre a linha da unidade que deseja analisar.": "Chcete-li zobrazit více informací o prodejně, například její umístění a nejčastěji připravované recepty, klikněte na řádek jednotky, kterou chcete analyzovat.",
    "tutorial.Criar receita": "Vytvořit recept",
    "tutorial.No cookbook você pode criar suas próprias receitas! Clique em Criar Receita e preencha todas as informações necessárias.": "V Cookbooku můžete vytvářet vlastní recepty! Klikněte na Vytvořit recept a vyplňte všechny potřebné informace.",
    "tutorial.Editar ou excluir um usuário": "Upravit nebo odstranit uživatele",
    "tutorial.Para excluir ou editar as informações de um usuário já cadastrado, clique no menu lateral e selecione a opção desejada.": "Chcete-li upravit nebo odstranit již registrovaného uživatele, klikněte na boční menu a vyberte požadovanou možnost.",
    "tutorial.Gerenciamento de usuários": "Správa uživatelů",
    "tutorial.Aqui você pode gerenciar seus usuários com mais facilidade. Ao clicar em + Usuário, você poderá adicionar um novo usuário ou criar um novo tipo de usuário.": "Zde můžete snadno spravovat své uživatele. Kliknutím na + Uživatel můžete přidat nového uživatele nebo vytvořit nový typ uživatele.",
    "tutorial.Suas receitas": "Vaše recepty",
    "tutorial.Pelo cookbook você também encontra suas próprias receitas, além de poder criá-las! Clique em Receitas Salvas para visualizar as receitas que foram salvas do cookbook da Prática e também as criadas por você.": "V Cookbooku najdete také své vlastní recepty a můžete vytvářet nové! Klikněte na Uložené recepty pro zobrazení receptů uložených z Cookbooku Prática i těch, které jste vytvořili sami.",
    "tutorial.Filtros do Cookbook": "Filtry Cookbooku",
    "tutorial.Para facilitar a navegação pelas receitas, você pode aplicar filtros a elas. Basta clicar no filtro desejado e escolher uma de suas opções.": "Pro snadnější procházení receptů můžete použít filtry. Stačí kliknout na požadovaný filtr a vybrat jednu z možností.",
    "tutorial.Cookbook": "Cookbook",
    "tutorial.No cookbook, em Receitas Disponíveis, você encontrará as receitas criadas pelos Chefs da Prática e poderá utilizá-las sempre que quiser.": "V sekci Dostupné recepty v Cookbooku najdete recepty vytvořené šéfkuchaři Prática a můžete je kdykoli použít.",
    "tutorial.Atualizar equipamentos": "Aktualizovat zařízení",
    "tutorial.Para enviar uma atualização a seus equipamentos, clique em Atualizar Equipamentos, selecione os modelos que deseja atualizar e a forma como deseja realizar essa atualização - via wi-fi ou pen drive. Depois disso, clique em Confirmar.": "Chcete-li odeslat aktualizaci do svých zařízení, klikněte na Aktualizovat zařízení, vyberte modely, které chcete aktualizovat, a způsob aktualizace – přes Wi-Fi nebo USB disk. Poté klikněte na Potvrdit.",
    "tutorial.Adicionar equipamento": "Přidat zařízení",
    "tutorial.Para adicionar um equipamento à sua conta, clique em Adicionar Equipamento e preencha as informações do modal. Depois disso, clique em Salvar.": "Chcete-li přidat zařízení ke svému účtu, klikněte na Přidat zařízení, vyplňte informace v dialogovém okně a poté klikněte na Uložit.",
    "tutorial.Editar equipamento": "Upravit zařízení",
    "tutorial.Para desvincular um equipamento ou editar suas informações, clique no menu lateral e selecione a opção desejada.": "Chcete-li zařízení odpojit nebo upravit jeho informace, klikněte na boční menu a vyberte požadovanou možnost.",
    "tutorial.Seus equipamentos": "Vaše zařízení",
    "tutorial.Aqui você visualizará todos os equipamentos cadastrados em sua plataforma.": "Zde uvidíte všechna zařízení registrovaná na vaší platformě.",
    "tutorial.Restaurar arquivos": "Obnovit soubory",
    "tutorial.Para restaurar um arquivo excluído ou deletá-lo permanentemente, clique no menu lateral e selecione a opção desejada.": "Chcete-li obnovit smazaný soubor nebo jej trvale odstranit, klikněte na boční menu a vyberte požadovanou možnost.",
    "tutorial.Lixeira": "Koš",
    "tutorial.Os menus excluídos serão mantidos na Lixeira por 30 dias. Depois desse prazo serão excluídos permanentemente.": "Smazaná menu budou uchovávána v koši po dobu 30 dnů. Po uplynutí této doby budou trvale odstraněna.",
    "tutorial.Salvar edições de usuário": "Uložit změny uživatele",
    "tutorial.Depois de completar o cadastro dos usuários, clique em Salvar.": "Po dokončení registrace uživatelů klikněte na Uložit.",
    "tutorial.Criar menu": "Vytvořit menu",
    "tutorial.Para criar e personalizar um menu, clique em Criar Menu e preencha as informações necessárias no modal. Você pode editar um menu a qualquer momento.": "Chcete-li vytvořit a přizpůsobit menu, klikněte na Vytvořit menu a vyplňte potřebné informace v dialogovém okně. Menu můžete kdykoli upravit.",
    "tutorial.Importar menu": "Importovat menu",
    "tutorial.Para importar um menu, clique em Importar Menu e selecione o modelo e versão do equipamento.": "Pro import menu klikněte na Importovat menu a vyberte model a verzi zařízení.",
    "tutorial.Criar grupo": "Vytvořit skupinu",
    "tutorial.Para organizar suas receitas em grupos, clique em Criar Grupo e preencha as informações necessárias no modal.": "Chcete-li organizovat recepty do skupin, klikněte na Vytvořit skupinu a vyplňte potřebné informace v dialogovém okně.",
    "tutorial.Tipos de usuário": "Typy uživatelů",
    "tutorial.Agora você também pode criar tipos de usuários com permissões específicas para atender melhor a sua organização.": "Nyní můžete vytvářet typy uživatelů se specifickými oprávněními, která lépe odpovídají potřebám vaší organizace.",
    "tutorial.Gerenciamento de contas": "Správa účtů",
    "tutorial.Se caso outra pessoa da sua organização também migrou a conta principal da empresa, aqui você pode unir as duas contas.": "Pokud někdo jiný ve vaší organizaci také migroval hlavní účet společnosti, můžete zde oba účty sloučit.",
    "tutorial.Para completar o registro de seus equipamentos, abra o menu lateral, clique em Editar e preencha as informações de Grupo.": "Pro dokončení registrace zařízení otevřete boční menu, klikněte na Upravit a vyplňte informace o skupině.",
    "tutorial.Para completar o cadastro dos usuários, abra o menu lateral, clique em Editar e preencha a informação referente ao Grupo de equipamentos a qual ele faz parte.": "Pro dokončení registrace uživatelů otevřete boční menu, klikněte na Upravit a vyplňte informaci o skupině zařízení, do které uživatel patří.",
    "tutorial.Grupos de equipamentos": "Skupiny zařízení",
    "tutorial.Na aba Grupos você pode visualizar os grupos cadastrados e os equipamentos distribuídos entre eles. Além disso, é possível cadastrar novos grupos e editar os já cadastrados.": "Na kartě Skupiny můžete zobrazit registrované skupiny a zařízení mezi nimi rozdělená. Kromě toho můžete vytvářet nové skupiny a upravovat již existující.",
    "tutorial.Detalhes de grupos": "Podrobnosti skupin",
    "tutorial.Para visualizar mais informações sobre o grupo, como localização e receitas mais preparadas, clique sobre a linha que deseja analisar.": "Chcete-li zobrazit více informací o skupině, například její umístění a nejčastěji připravované recepty, klikněte na řádek, který chcete analyzovat.",
    "tutorial.Equipamentos em grupos": "Zařízení ve skupinách",
    "tutorial.Ao clicar sobre a linha de um equipamento cadastrado em um grupo, você pode visualizar mais estatísticas e informações sobre ele, além de poder solicitar um atendimento ou disparar atualizações.": "Kliknutím na řádek zařízení registrovaného ve skupině můžete zobrazit více statistik a informací, požádat o servis nebo spustit aktualizace.",
    "tutorial.Grupos": "Skupiny",
    "tutorial.Atualização e cache": "Aktualizace a mezipaměť",
    "tutorial.Para atualizar a plataforma e corrigir eventuais problemas de cache, clique aqui.": "Klikněte zde pro aktualizaci platformy a odstranění případných problémů s mezipamětí.",
    "tutorial.Dados dos equipamentos": "Údaje o zařízeních",
    "tutorial.Ao clicar sobre a linha de um equipamento, você pode visualizar mais estatísticas e informações sobre ele, como as receitas mais preparadas, limpezas realizadas e outros dados relevantes.": "Kliknutím na řádek zařízení můžete zobrazit více statistik a informací, například nejčastěji používané recepty, provedená čištění a další relevantní údaje.",
    "tutorial.Para alterar o idioma de sua plataforma, clique em Idioma e selecione a linguagem desejada.": "Chcete-li změnit jazyk platformy, klikněte na Jazyk a vyberte požadovaný jazyk.",
    "tutorial.Alterar idioma": "Změnit jazyk",
    "tutorial.Para editar ou configurar sua conta, clique em seu nome e selecione a opção desejada.": "Chcete-li upravit nebo nastavit svůj účet, klikněte na své jméno a vyberte požadovanou možnost.",
    "tutorial.Editar conta": "Upravit účet",
    "tutorial.Total de Usuários Cadastrados em sua conta.": "Celkový počet uživatelů registrovaných ve vašem účtu.",
    "tutorial.Home": "Domů",
    "tutorial.Localização de seus equipamentos, sendo possível expandir o mapa para melhor visualização;": "Umístění vašich zařízení s možností zvětšení mapy pro lepší přehled;",
    "tutorial.Atualizações referentes a versão dos equipamentos vinculados a sua conta;": "Aktualizace týkající se verzí zařízení připojených k vašemu účtu;",
    "tutorial.Total de Receitas Cadastradas;": "Celkový počet registrovaných receptů;",
    "tutorial.Menus Disponíveis;": "Dostupná menu;",
    "tutorial.Esta é a sua home! Aqui você encontra um resumo geral sobre sua conta;": "Toto je vaše domovská stránka! Zde najdete celkový přehled o svém účtu;",
    "tutorial.Clique nas abas do menu para explorar a plataforma e conhecer tudo o que ela pode oferecer.": "Klikněte na karty menu a prozkoumejte platformu a vše, co nabízí.",
    "tutorial.Exportar menu": "Exportovat menu",
    "tutorial.Depois de personalizar seu menu, exporte-o para seus equipamentos pela internet ou por pen drive.": "Po přizpůsobení menu jej exportujte do svých zařízení přes internet nebo pomocí USB disku.",
    "tutorial.Na aba Localização você pode visualizar os endereços já cadastrados, além de criar localizações precisas para vincular seus equipamentos a elas.": "Na kartě Umístění můžete zobrazit již registrované adresy a vytvářet přesná umístění pro přiřazení vašich zařízení.",
    "tutorial.Localização": "Umístění",
    "tutorial.Informações sobre o equipamento": "Informace o zařízení",
    "tutorial.Equipamentos Ligados e quantos estão enviando dados de uso;": "Připojená zařízení a kolik z nich odesílá údaje o používání;",

    //RECOVER ACCOUNT
    "recoverAccount.Para prosseguir, selecione a categoria na qual você se encaixa:": "Pro pokračování vyberte kategorii, do které patříte:",
    "recoverAccount.Deseja acessar a plataforma como DISTRIBUIDOR? Crie sua conta clicando em EMPRESA e entre em contato conosco para liberarmos os demais acessos.": "Chcete přistupovat k platformě jako DISTRIBUTOR? Vytvořte si účet kliknutím na SPOLEČNOST a kontaktujte nás, abychom vám zpřístupnili další oprávnění.",
    "recoverAccount.A qual organização você pertence": "Ke které organizaci patříte?",

    //RECOVER PASSWORD PAGE
    "recoverPassword.E-mail para recuperação de senha": "E-mail pro obnovení hesla",
    "recoverPassword.Informe o e-mail cadastrado na plataforma": "Zadejte e-mail registrovaný na platformě",
    "recoverPassword.E-mail inválido. Por favor, verifique": "Neplatný e-mail. Zkontrolujte jej prosím",
    "recoverPassword.RECUPERAR SENHA": "OBNOVIT HESLO",
    "recoverPassword.EM BREVE VOCÊ RECEBERÁ UM E-MAIL COM O LINK DE RECUPERAÇÃO DE SENHA": "Brzy obdržíte e-mail s odkazem pro obnovení hesla",
    "recoverPassword.Informe seu e-mail": "Zadejte svůj e-mail",
    "recoverPassword.Crie uma nova senha": "Vytvořte nové heslo",
    "recoverPassword.O campo senha deve conter no mínimo 6 caracteres": "Pole heslo musí obsahovat alespoň 6 znaků",
    "recoverPassword.Confirme sua senha": "Potvrďte své heslo",
    "recoverPassword.As senhas devem ser iguais": "Hesla se musí shodovat",
    "recoverPassword.ENTRAR": "PŘIHLÁSIT SE",
    "recoverPassword.EM BREVE VOCÊ RECEBERÁ UM E-MAIL PARA CONFIRMAR SUA IDENTIDADE": "Brzy obdržíte e-mail pro potvrzení své identity",
    "recoverPassword.CONTINUAR": "POKRAČOVAT",
    "recoverPassword.CONFIRMAR": "POTVRDIT",
    "recoverPassword.Por segurança, o acesso à conta foi bloqueado devido a tentativas de login incorretas.": "Z bezpečnostních důvodů byl přístup k účtu zablokován kvůli nesprávným pokusům o přihlášení.",
    "recoverPassword.Para desbloquear sua conta, siga as instruções após clicar no botão abaixo:": "Pro odblokování účtu postupujte podle pokynů po kliknutí na tlačítko níže:",
    "recoverPassword.Desbloquear conta": "Odblokovat účet",
    "recoverPassword.Você recebeu um e-mail para iniciar o desbloqueio de sua conta.": "Obdrželi jste e-mail pro zahájení odblokování účtu.",
    "recoverPassword.Verifique sua caixa de entrada ou spam.": "Zkontrolujte svou doručenou poštu nebo složku spam.",
    "recoverPassword.Verifique seu e-mail": "Zkontrolujte svůj e-mail",
    "recoverPassword.Informe seu e-mail de login e crie uma nova senha para acessar sua conta.": "Zadejte svůj přihlašovací e-mail a vytvořte nové heslo pro přístup ke svému účtu.",

    // EXPORT
    "export.Limpezas": "Čištění",
    "export.Eventos": "Události",
    "export.Lista de receitas preparadas": "Seznam provedených receptů",
    "export.Lista de limpezas realizadas": "Seznam provedených čištění",
    "export.Lista de eventos ocorridos": "Seznam zaznamenaných událostí",
    "export.Exportar dados": "Exportovat data",
    "export.Exportar": "Exportovat",
    "export.Informações do equipamento": "Informace o zařízení",
    "export.Dados exportados com sucesso!": "Data byla úspěšně exportována!",
    "export.Não foi possível exportar os dados. Por favor, tente novamente mais tarde.": "Data se nepodařilo exportovat. Zkuste to prosím znovu později.",
    "export.Detalhes do menu": "Podrobnosti menu",
    "export.Detalhes de receitas": "Podrobnosti receptů",
    "export.Detalhes e Passos": "Podrobnosti a kroky",
    "export.Exportando dados. Em breve o arquivo estará disponível!": "Data se exportují. Soubor bude brzy k dispozici!",
    "export.Resumo dos passos": "Souhrn kroků",
    "export.salvar imagem": "uložit obrázek",
    "export.Nenhum modelo foi selecionado": "Nebyl vybrán žádný model",

    // COMPANIES PAGE
    "company.Procurar companhia": "Vyhledat společnost",
    "company.Adicionar companhia": "Přidat společnost",
    "company.AINDA NÃO HÁ COMPANHIAS CADASTRADAS :(": "ZATÍM NEJSOU REGISTROVÁNY ŽÁDNÉ SPOLEČNOSTI :(",
    "company.description.AINDA NÃO HÁ COMPANHIAS CADASTRADAS :(": "Klikněte na tlačítko v pravém horním rohu a přidejte společnosti.",
    "company.Adicionar": "Přidat",
    "company.ADICIONAR EQUIPAMENTOS": "PŘIDAT ZAŘÍZENÍ",
    "company.Preencha pelo menos um número de série": "Vyplňte alespoň jedno sériové číslo",
    "company.Informe os números de série": "Zadejte sériová čísla",
    "company.Número de série": "Sériové číslo",
    "company.Para incluir vários equipamentos, separe-os com ponto e vírgula (;).": "Chcete-li přidat více zařízení, oddělte je středníkem (;).",
    "company.Informe o número de série do equipamento que deseja adicionar abaixo.": "Níže zadejte sériové číslo zařízení, které chcete přidat.",
    "company.Números de série adicionados com sucesso!": "Sériová čísla byla úspěšně přidána!",
    "company.Não foi possível adicionar os números de série. Tente novamente mais tarde": "Sériová čísla nebylo možné přidat. Zkuste to prosím znovu později.",
    "company.adicionar": "přidat",
    "company.Procurar por companhia ou ID": "Vyhledat společnost nebo ID",
    "company.Companhia": "Společnost",
    "company.E-mail principal": "Hlavní e-mail",
    "company.Local": "Místo",
    "company.Companhia adicionada com sucesso!": "Společnost byla úspěšně přidána!",
    "company.Não foi possível cadastrar a companhia": "Společnost nebylo možné zaregistrovat",
    "company.REMOVER COMPANHIA": "ODEBRAT SPOLEČNOST",
    "company.Você deseja remover a companhia definitivamente? Os equipamentos vinculados a ela também serão removidos de sua conta.": "Opravdu chcete společnost trvale odstranit? Zařízení k ní přiřazená budou také odstraněna z vašeho účtu.",
    "company.Esta ação não poderá ser desfeita.": "Tuto akci nelze vrátit zpět.",
    "company.A companhia foi removida com sucesso!": "Společnost byla úspěšně odstraněna!",
    "company.Não foi possível remover a companhia": "Společnost nebylo možné odstranit",
    "company.Quant. de fornos": "Počet pecí",
    "company.Fornos conectados": "Připojené pece",
    "company.Fornos não conectados": "Nepřipojené pece",
    "company.AINDA NÃO HÁ EQUIPAMENTOS CADASTRADOS :(": "ZATÍM NEJSOU REGISTROVÁNA ŽÁDNÁ ZAŘÍZENÍ :(",
    "company.description.AINDA NÃO HÁ EQUIPAMENTOS CADASTRADOS :(": "Klikněte na tlačítko v pravém horním rohu a přidejte zařízení.",
    "company.Procurar número de série": "Vyhledat sériové číslo",
    "company.excluir equipamento": "odstranit zařízení",
    "company.Você deseja excluir o equipamento selecionado definitivamente?": "Opravdu chcete vybrané zařízení trvale odstranit?",
    "company.Número de série editado com sucesso!": "Sériové číslo bylo úspěšně upraveno!",
    "company.Não foi possível editar o número de série. Tente novamente mais tarde": "Sériové číslo nebylo možné upravit. Zkuste to prosím znovu později.",
    "company.Informe o número de série": "Zadejte sériové číslo",
    "company.Preencha um número de série": "Vyplňte sériové číslo",
    "company.EDITAR EQUIPAMENTO": "UPRAVIT ZAŘÍZENÍ",
    "company.Modelo": "Model",
    "company.Cadastro": "Registrace",
    "company.Conectado": "Připojeno",
    "company.SELECIONE EQUIPAMENTOS PARA EXCLUIR": "VYBERTE ZAŘÍZENÍ K ODSTRANĚNÍ",
    "company.O equipamento foi removida com sucesso!": "Zařízení bylo úspěšně odstraněno!",
    "company.Não foi possível remover o equipamento": "Zařízení nebylo možné odstranit",
    "company.Caracteres especiais não são permitidos, exceto o ponto e vírgula (';')": "Speciální znaky nejsou povoleny, kromě středníku (';')",
    "company.Preencha o número de série sem caracteres especiais": "Zadejte sériové číslo bez speciálních znaků",
    "company.Um ou mais números de série já estão provisionados para outra companhia": "Jedno nebo více sériových čísel je již přiřazeno jiné společnosti.",
    "company.Um ou mais números de série já estão conectados na conta de outra companhia": "Jedno nebo více sériových čísel je již připojeno k účtu jiné společnosti.",

    // Error
    "error.Ocorreu um erro ao carregar esta seção": "Při načítání této sekce došlo k chybě",
    "error.Tentar novamente": "Zkusit znovu",

    //DASHBOARDS
    "dashboard.fornos vinculados": "PŘIPOJENÉ PECE",
    "dashboard.ativos": "Aktivní",
    "dashboard.inativos": "Neaktivní",
    "dashboard.sem status": "Bez stavu",
    "dashboard.fornos atualizados": "AKTUALIZOVANÉ PECE",
    "dashboard.com a versão do software mais recente": "S nejnovější verzí softwaru",
    "dashboard.chamados": "POŽADAVKY",
    "dashboard.veja mais no app cliente": "Zobrazit více v zákaznické aplikaci",
    "dashboard.limpeza diária": "DENNÍ ČIŠTĚNÍ",
    "dashboard.dos fornos estão em dia": "pecí je v pořádku",
    "dashboard.top 3": "Top 3",
    "dashboard.média de execuções de receitas por hora": "Průměrný počet spuštění receptů za hodinu",
    "dashboard.avisos": "UPOZORNĚNÍ",
    "dashboard.sem avisos por aqui": "ŽÁDNÁ UPOZORNĚNÍ",
    "dashboard.ver mais": "Zobrazit více",
    "dashboard.abertos pela plataforma IOK": "Otevřeno prostřednictvím platformy IOK",
    "dashboard.equipamentos": "Zařízení",
    "dashboard.receitas": "Recepty",
    "dashboard.executada": "spuštěno",
    "dashboard.vezes": "krát",
    "dashboard.forno": "Pec",
    "dashboard.média por hora": "Průměr za hodinu",
    "dashboard.editar": "upravit",
    "dashboard.endereço:": "Adresa:",
    "dashboard.cep:": "PSČ:",
    "dashboard.estatísticas": "Statistiky",
    "dashboard.uso de equipamento": "Využití zařízení",
    "dashboard.pico de uso": "Špička využití",
    "dashboard.receitas mais executadas por equipamento": "Nejčastěji spouštěné recepty podle zařízení",
    "dashboard.recolher": "sbalit",
    "dashboard.TOROS TC CONECTADOS:": "PŘIPOJENÉ TOROS TC:",
    "dashboard.Consumo de energia - Lastro Toro TC": "Spotřeba energie - Lastro Toro TC",
    "dashboard.tootilp": "Je to součet všech receptů spuštěných během aktuálního dne dělený počtem hodin, po které je pec zapnutá.",
    "dashboard.noResults": "Nebyly nalezeny žádné výsledky :(",
    "dashboard.Preaquecimento": "Předehřev",
    "dashboard.Esfriamento": "Chlazení",
    "dashboard.Execução de receitas": "Provádění receptů",
    "dashboard.Execução de receitas TSi": "Provádění receptů TSi",
    "dashboard.Modo manual": "Manuální režim",
    "dashboard.Limpeza": "Čištění",
    "dashboard.Porta": "Dveře",
    "dashboard.Erros e alertas": "Chyby a upozornění",
    "dashboard.Parâmetros": "Parametry",
    "dashboard.SEM DADOS POR AQUI": "ZDE NEJSOU ŽÁDNÁ DATA",
    "dashboard.AINDA SEM GRÁFICOS POR AQUI": "ZATÍM ZDE NEJSOU ŽÁDNÉ GRAFY",
    "dashboard.description.AINDA SEM GRÁFICOS POR AQUI": "Vyberte položky ze seznamu vedle pro vytvoření grafů nebo klikněte na řádek pro zobrazení více podrobností.",

    //INFORMAÇÕES IOK
    "iokInformation.search.placeholder": "Hledat článek",
    "iokInformation.article.openInHelpCenter": "Zobrazit článek v Centru nápovědy",
    "iokInformation.aboutPlatform.platformFeatures.title": "Platforma a její funkce",
    "iokInformation.aboutPlatform.platformFeatures.linkLabel": "Stáhnout kompletní prezentaci",
    "iokInformation.aboutPlatform.manual.title": "Návod k použití",
    "iokInformation.aboutPlatform.manual.linkLabel": "Stáhnout návod",
    "iokInformation.aboutPlatform.privacy.title": "Zásady ochrany osobních údajů",
    "iokInformation.aboutPlatform.privacy.linkLabel": "Stáhnout zásady",
    "iokInformation.aboutPlatform.api.title": "Externí API",
    "iokInformation.aboutPlatform.api.linkLabel": "Stáhnout dokument",

    //Telemetry TSI
    "telemetry.EQUIPMENT_TURN_ON": "Zařízení zapnuto",
    "telemetry.SENSORS_VALUES": "Hodnoty senzorů",
    "telemetry.ERROR_DETECTED": "Zjištěna chyba",
    "telemetry.TIME_ADDED": "Přidán čas",
    "telemetry.GN_ADDED": "Přidána GN",
    "telemetry.GN_RELEASED": "GN spuštěna",
    "telemetry.GN_FINISHED": "GN dokončena",

    "telemetry.HEAVY_CLEANING_CANCELED": "Intenzivní čištění zrušeno",
    "telemetry.CLEANING_CANCELED": "Čištění zrušeno",
    "telemetry.CLEANING_RESTARTED": "Čištění restartováno",
    "telemetry.CLEANING_VAPORIZATION_STEP": "Krok napařování při čištění",
    "telemetry.CLEANING_SUPPLY_STEP": "Krok napouštění při čištění",
    "telemetry.CLEANING_CIRCULATION_STEP": "Krok cirkulace při čištění",
    "telemetry.CLEANING_DEPLETION_STEP": "Krok vypouštění při čištění",
    "telemetry.CLEANING_RISING_STEP": "Krok oplachování při čištění",
    "telemetry.CLEANING_STARTED": "Čištění zahájeno",
    "telemetry.CLEANING_FINISHED": "Čištění dokončeno",
    "telemetry.RECOMMENDED_CLEANING": "Doporučené čištění",
    "telemetry.VALID_PASSWORD_CLEANING": "Platné heslo při čištění",
    "telemetry.INVALID_PASSWORD_CLEANING": "Neplatné heslo při čištění",

    "telemetry.RECIPE_STARTED": "Recept spuštěn",
    "telemetry.RECIPE_FINISHED": "Recept dokončen",
    "telemetry.RECIPE_CANCELED": "Recept zrušen",
    "telemetry.RECIPE_STEP_CHANGED": "Krok receptu změněn",
    "telemetry.RECIPE_PAUSED": "Recept pozastaven",
    "telemetry.RECIPE_RESUMED": "Recept obnoven",
    "telemetry.DROP_ENERGY_SUPPLY": "Obnoveno po výpadku napájení",
    "telemetry.RESUME_RECIPE_CANCELED": "Obnovení receptu zrušeno",

    "telemetry.PRE_HEAT_STARTED": "Předehřev zahájen",
    "telemetry.PRE_HEAT_FINISHED": "Předehřev dokončen",
    "telemetry.OPERATION_CONTINUE_STARTED": "Obnovení provozu zahájeno",
    "telemetry.OPERATION_CONTINUE_FINISHED": "Obnovení provozu dokončeno",
    "telemetry.HOLD_TEMPERATURE_STARTED": "Udržování teploty zahájeno",
    "telemetry.HOLD_TEMPERATURE_FINISHED": "Udržování teploty dokončeno",
    "telemetry.COOL_DOWN_STARTED": "Chlazení zahájeno",
    "telemetry.COOL_DOWN_FINISHED": "Chlazení dokončeno",
    "telemetry.NOCTURNAL_COOKING_STARTED": "Noční pečení zahájeno",
    "telemetry.NOCTURNAL_COOKING_FINISHED": "Noční pečení dokončeno",
    "telemetry.SEALING_STARTED": "Zapečení zahájeno",
    "telemetry.SEALING_FINISHED": "Zapečení dokončeno",
    "telemetry.TURBO_GRILL_STARTED": "Turbo Grill zahájen",
    "telemetry.TURBO_GRILL_FINISHED": "Turbo Grill dokončen",
    "telemetry.TURBO_GRILL_ACTIVATED": "Turbo Grill aktivován",
    "telemetry.TURBO_GRILL_DISABLED": "Turbo Grill deaktivován",

    "telemetry.MOISTURE_CHANGED": "Vlhkost změněna",
    "telemetry.TURBINE_CHANGED": "Hodnota turbíny změněna",
    "telemetry.SET_POINT_CHANGED": "Teplota komory změněna",
    "telemetry.STEAM_CHANGED": "Pára změněna",
    "telemetry.PROBE_CHANGED": "Teplota sondy změněna",
    "telemetry.TIME_CHANGED": "Čas změněn",
    "telemetry.DOOR_OPENED": "Dveře otevřeny",
    "telemetry.DOOR_CLOSED": "Dveře zavřeny",

    "telemetry.PROBE_CONTROL_SELECTED": "Zvoleno řízení pomocí sondy",
    "telemetry.TIME_CONTROL_SELECTED": "Zvoleno řízení podle času",
    "telemetry.MANUAL_STEAM_INJECTED": "Ruční vstřikování páry",
    "telemetry.AUTOMATIC_STEAM_INJECTED": "Automatické vstřikování páry",

    "telemetry.DATABASE_CREATED": "Databáze vytvořena",
    "telemetry.EXIT_FUNCTION": "Funkce ukončena",
    "telemetry.CONSUMPTION": "Spotřeba",
    "telemetry.STANDBY": "Pohotovostní režim",

    "telemetry.ANALYTICS_ERROR_BAD_REQUEST": "Chyba analytiky: Neplatný požadavek",
    "telemetry.ANALYTICS_ERROR_FORBIDDEN": "Chyba analytiky: Přístup odepřen",
    "telemetry.ANALYTICS_ERROR_SERVER": "Chyba analytiky: Chyba serveru",
    "telemetry.ANALYTICS_ERROR_UNEXPECTED": "Chyba analytiky: Neočekávaná chyba",
    "telemetry.ANALYTICS_SUCCESS": "Analytika úspěšně dokončena",

    "telemetry.STEP": "Krok",
    "telemetry.STEAM": "Pára",
    "telemetry.PROBE": "Sonda",
    "telemetry.TURBINE": "Turbína",
    "telemetry.OCCURRENCES": "výskyt(y)",
    "telemetry.FUNC_USER_RECIPE": "Uživatelský recept",
    "telemetry.FUNC_TSI_RECIPE": "Recept TSi",
    "telemetry.FUNC_DELTA_T": "Delta T",
    "telemetry.FUNC_STEAM": "Pára",
    "telemetry.FUNC_COMBINED_STEAM": "Kombinovaná pára",
    "telemetry.FUNC_HOT_AIR": "Horký vzduch",
    "telemetry.FUNC_NOCTURNAL_COOKING": "Noční pečení",
    "telemetry.FUNC_REGENERATE": "Regenerace",
    "telemetry.FUNC_MULTIPLE_COOKING": "Vícenásobné pečení",

    "haccp.filterBy": "Filtrovat podle",
    "haccp.export.generating": "Tabulka HACCP se generuje a bude brzy automaticky stažena.",
    "haccp.voltage": "Napětí",
    "haccp.voltageReading": "Měření napětí",
    "haccp.voltageOscillation": "Kolísání napětí během dne",
    "haccp.status.normal": "Normální",
    "haccp.status.attention": "Pozor",
    "haccp.status.critical": "Kritické",
    "haccp.dateTime": "Datum/Čas",
    "haccp.errorDetected": "Zjištěna chyba/upozornění",
    "haccp.detected": "zjištěno",
    "haccp.errorTypeLabel": "Typ chyby/upozornění",
    "haccp.severityLabel": "Závažnost",
    "haccp.severity.error": "Chyba",
    "haccp.severity.alert": "Upozornění",
    "haccp.error.canNetwork": "Chyba sítě CAN",
    "haccp.error.chamberSensor": "Chyba senzoru komory",
    "haccp.error.steamSensor": "Chyba senzoru páry",
    "haccp.error.probeSensor": "Chyba sondy",
    "haccp.error.noWater": "Chyba nedostatku vody",
    "haccp.error.panelTemp": "Chyba teploty panelu",
    "haccp.error.motor": "Chyba motoru",
    "haccp.error.motorComm": "Chyba komunikace motoru",
    "haccp.error.hygieneIncomplete": "Chyba nedokončeného čištění",
    "haccp.error.familyModel": "Chyba řady/modelu",
    "haccp.error.boardTemp": "Chyba teploty desky",
    "haccp.error.energyModule": "Chyba energetického modulu",
    "haccp.error.i2c": "Chyba I2C",
    "haccp.error.gas": "Chyba plynu",
    "haccp.loading": "Načítání...",
    "haccp.quantity": "Množství",
    "haccp.executions": "Provedení",
    "haccp.manual.mode": "Režim",
    "haccp.manual.tempC": "Teplota (°C)",
    "haccp.manual.timeMin": "Čas (min)",
    "haccp.manual.probeC": "Sonda (°C)",
    "haccp.manual.steamPct": "Pára %",
    "haccp.cleaning.label": "Čištění",
    "haccp.cleaning.recommendedLabel": "Doporučené čištění",
    "haccp.cleaning.status.completed": "Dokončeno",
    "haccp.cleaning.status.restarted": "Restartováno",
    "haccp.cleaning.status.interrupted": "Přerušeno",
    "haccp.status.label": "Stav",
    "haccp.error": "Chyba",
    "haccp.consumption.water": "Spotřeba vody",
    "haccp.consumption.energy": "Spotřeba energie",
    "haccp.short.temp": "Tepl.",
    "haccp.short.time": "Čas",
    "haccp.day": "Den",
    "haccp.recipeExecutions": "Počet provedení",
    "STEAM": "Pára",
    "COMBINED_STEAM": "Kombinovaná pára",
    "PROBE": "Sonda",
    "TURBINE": "Turbína",
    "HOT_AIR": "Horký vzduch",
    "NOCTURNAL_COOKING": "Noční pečení",
    "REGENERATE": "Regenerace",
    "MULTIPLE_COOKING": "Vícenásobné pečení",
    "DELTA_T": "Delta T",

    //CSAT
    "csat.AVALIE SUA EXPERIÊNCIA": "OHODNOŤTE SVOU ZKUŠENOST",
    "csat.Como você avalia sua experiência com": "Jak hodnotíte svou zkušenost s",
    "csat.Muito insatisfeito": "Velmi nespokojen",
    "csat.Insatisfeito": "Nespokojen",
    "csat.Neutro": "Neutrální",
    "csat.Satisfeito": "Spokojen",
    "csat.Muito satisfeito": "Velmi spokojen",
    "csat.Utilize o espaço abaixo para deixar suas sugestões:": "Využijte níže uvedený prostor pro své návrhy:",
    "csat.Digite aqui": "Pište zde",
    "csat.Obrigado por responder à nossa pesquisa!": "Děkujeme za vyplnění našeho průzkumu!",
    "csat.Selecione uma nota para continuar": "Pro pokračování vyberte hodnocení",
    "csat.Enviar": "Odeslat",
    "csat.a criação de receitas": "vytváření receptů",
    "csat.o cadastro de equipamentos": "registraci zařízení",
    "csat.o cadastro de usuários": "registraci uživatelů",
    "csat.a criação de menus": "vytváření menu",
    "csat.a deleção de receitas": "mazání receptů",
    "csat.a reordenação de receitas": "přeuspořádání receptů",
    "csat.o envio de software": "odesílání softwaru",
    "csat.o envio de menus": "odesílání menu",
    "csat.o uso de receitas do Cookbook": "používání receptů z Cookbooku"
  },
};

export default cs;


